export const PAYMENT_METHOD_OPTIONS = [
  { value: 'wire', label: 'Wire doméstico', countryCode: null, soon: false },
  {
    value: 'international_swift',
    label: 'SWIFT internacional',
    countryCode: null,
    soon: false
  },
  { value: 'ach', label: 'ACH', countryCode: 'US', soon: false },
  { value: 'rtp', label: 'RTP Instantâneo', countryCode: 'US', soon: false },
  { value: 'transfers_3', label: 'Transfers 3.0', countryCode: 'AR', soon: false },
  { value: 'ach_colombia', label: 'ACH Colômbia', countryCode: 'CO', soon: false },
  { value: 'spei', label: 'SPEI', countryCode: 'MX', soon: false },
  { value: 'sepa', label: 'SEPA EUR', countryCode: 'EU', soon: false }
];

export const ACCOUNT_TYPE_OPTIONS = [
  { text: 'Conta corrente', value: 'checking' },
  { text: 'Poupança', value: 'savings' }
];

export const ACCOUNT_CLASS_OPTIONS = [
  { text: 'Individual', value: 'individual' },
  { text: 'Empresarial', value: 'business' }
];

export const RECIPIENT_RELATIONSHIP_OPTIONS = [
  { text: 'Parte relacionada', value: 'first_party' },
  { text: 'Funcionário', value: 'employee' },
  { text: 'Prestador de serviço', value: 'independent_contractor' },
  { text: 'Fornecedor', value: 'vendor_or_supplier' },
  { text: 'Subsidiária ou afiliada', value: 'subsidiary_or_affiliate' },
  { text: 'Parceiro comercial', value: 'merchant_or_partner' },
  { text: 'Cliente', value: 'customer' },
  { text: 'Locador', value: 'landlord' },
  { text: 'Familiar', value: 'family' },
  { text: 'Outros', value: 'other' }
];

export const COLOMBIA_DOCUMENT_TYPE_OPTIONS = [
  { text: 'Cédula de Ciudadanía', value: 'CC' },
  { text: 'Cédula de Extranjería', value: 'CE' },
  { text: 'NIT', value: 'NIT' },
  { text: 'Pasaporte', value: 'PASS' },
  { text: 'PEP (Permiso Especial de Permanencia)', value: 'PEP' }
];

export const COLOMBIA_BANK_CODE_OPTIONS = [
  { text: 'Banco de Bogotá', value: '0001' },
  { text: 'Banco Popular', value: '0002' },
  { text: 'Banco de Occidente', value: '0023' },
  { text: 'Banco AV Villas', value: '0052' },
  { text: 'Banco Agrario', value: '0040' },
  { text: 'Banco Caja Social', value: '0051' },
  { text: 'Bancolombia', value: '0007' },
  { text: 'Banco de Colombia', value: '0009' },
  { text: 'Banco GNB Sudameris', value: '0012' },
  { text: 'Banco Falabella', value: '0014' },
  { text: 'Banco Santander', value: '0013' },
  { text: 'Banco Davivienda', value: '0051' },
  { text: 'Banco BBVA', value: '0013' },
  { text: 'Banco Cooperativo Coopcentral', value: '0056' }
];

export const TRANSFERS_3_TYPE_OPTIONS = [
  { text: 'CVU', value: 'cvu' },
  { text: 'CBU', value: 'cbu' }
];

/**
 * Regras de validação de código postal por país (ISO 3166-1 alpha-2).
 * regex: formato exigido
 * example: exemplo para exibir ao usuário
 */
export const POSTAL_CODE_RULES = {
  BR: { regex: /^\d{5}-?\d{3}$/, example: '01310-100' },
  US: { regex: /^\d{5}(-\d{4})?$/, example: '10115 ou 10115-1234' },
  GB: { regex: /^[A-Z]{1,2}\d[A-Z\d]?\s?\d[A-Z]{2}$/i, example: 'SW1A 1AA' },
  CA: { regex: /^[A-Z]\d[A-Z]\s?\d[A-Z]\d$/i, example: 'K1A 0B1' },
  DE: { regex: /^\d{5}$/, example: '10115' },
  FR: { regex: /^\d{5}$/, example: '75008' },
  ES: { regex: /^\d{5}$/, example: '28001' },
  IT: { regex: /^\d{5}$/, example: '00100' },
  PT: { regex: /^\d{4}-?\d{3}$/, example: '1000-001' },
  NL: { regex: /^\d{4}\s?[A-Z]{2}$/i, example: '1012 AB' },
  BE: { regex: /^\d{4}$/, example: '1000' },
  AT: { regex: /^\d{4}$/, example: '1010' },
  CH: { regex: /^\d{4}$/, example: '8001' },
  SE: { regex: /^\d{3}\s?\d{2}$/, example: '111 22' },
  NO: { regex: /^\d{4}$/, example: '0150' },
  DK: { regex: /^\d{4}$/, example: '1050' },
  FI: { regex: /^\d{5}$/, example: '00100' },
  PL: { regex: /^\d{2}-?\d{3}$/, example: '00-001' },
  IE: { regex: /^[A-Z\d]{3}\s?[A-Z\d]{4}$/i, example: 'D02 AF30' },
  JP: { regex: /^\d{3}-?\d{4}$/, example: '100-0001' },
  AU: { regex: /^\d{4}$/, example: '2000' },
  MX: { regex: /^\d{5}$/, example: '01000' },
  AR: { regex: /^[A-Z]?\d{4}[A-Z]{0,3}$/i, example: 'C1425' },
  CO: { regex: /^\d{6}$/, example: '110111' },
  IN: { regex: /^\d{6}$/, example: '110001' },
  CL: { regex: /^\d{7}$/, example: '8320000' },
};

/**
 * Países SEPA onde pagamentos para contas empresariais (business) não são suportados.
 * Nesses países, apenas account_class: individual é aceito pela BlindPay.
 * Fonte: https://blindpay.com/docs/kb/payment-methods
 */
export const SEPA_BUSINESS_BLOCKED_COUNTRIES = new Set(['AT', 'EE', 'FI', 'FR', 'LT', 'NO', 'PT']);

export const SEPA_COUNTRY_OPTIONS = [
  { text: 'Albânia', value: 'AL' },
  { text: 'Andorra', value: 'AD' },
  { text: 'Áustria', value: 'AT' },
  { text: 'Bélgica', value: 'BE' },
  { text: 'Bulgária', value: 'BG' },
  { text: 'Chipre', value: 'CY' },
  { text: 'Croácia', value: 'HR' },
  { text: 'Dinamarca', value: 'DK' },
  { text: 'Eslováquia', value: 'SK' },
  { text: 'Eslovênia', value: 'SI' },
  { text: 'Espanha', value: 'ES' },
  { text: 'Estônia', value: 'EE' },
  { text: 'Finlândia', value: 'FI' },
  { text: 'França', value: 'FR' },
  { text: 'Alemanha', value: 'DE' },
  { text: 'Grécia', value: 'GR' },
  { text: 'Hungria', value: 'HU' },
  { text: 'Irlanda', value: 'IE' },
  { text: 'Islândia', value: 'IS' },
  { text: 'Itália', value: 'IT' },
  { text: 'Letônia', value: 'LV' },
  { text: 'Liechtenstein', value: 'LI' },
  { text: 'Lituânia', value: 'LT' },
  { text: 'Luxemburgo', value: 'LU' },
  { text: 'Macedônia do Norte', value: 'MK' },
  { text: 'Malta', value: 'MT' },
  { text: 'Moldávia', value: 'MD' },
  { text: 'Mônaco', value: 'MC' },
  { text: 'Montenegro', value: 'ME' },
  { text: 'Noruega', value: 'NO' },
  { text: 'Países Baixos', value: 'NL' },
  { text: 'Polônia', value: 'PL' },
  { text: 'Portugal', value: 'PT' },
  { text: 'Reino Unido', value: 'GB' },
  { text: 'República Tcheca', value: 'CZ' },
  { text: 'Romênia', value: 'RO' },
  { text: 'San Marino', value: 'SM' },
  { text: 'Santa Sé (Vaticano)', value: 'VA' },
  { text: 'Suécia', value: 'SE' },
  { text: 'Suíça', value: 'CH' }
];

export const SPEI_PROTOCOL_OPTIONS = [
  { text: 'CLABE', value: 'clabe' },
  { text: 'Cartão de débito', value: 'debitcard' },
  { text: 'Número de telefone', value: 'phonenum' }
];

// Fonte: BlindPay GET /v1/available-bank-details?rail=spei_bitso.
// Códigos no formato oficial Bitso (37XXX desenvolvimento, 40XXX comerciais, 90XXX fintechs/cajas).
// Resincronizar quando a BlindPay publicar novos participantes.
export const SPEI_INSTITUTION_CODE_OPTIONS = [
  { text: 'Actinver', value: '40133' },
  { text: 'Afirme', value: '40062' },
  { text: 'Albo', value: '90721' },
  { text: 'Altor', value: '90660' },
  { text: 'Arcus FI', value: '90706' },
  { text: 'ASP Integra OPC', value: '90659' },
  { text: 'Babien', value: '37166' },
  { text: 'Banamex', value: '40002' },
  { text: 'Banco Azteca', value: '40127' },
  { text: 'Banco Covalto', value: '40154' },
  { text: 'Banco del Bajío', value: '40030' },
  { text: 'Banco Inbursa', value: '40036' },
  { text: 'Banco S3', value: '40160' },
  { text: 'Bancomext', value: '37006' },
  { text: 'Bancoppel', value: '40137' },
  { text: 'Bancrea', value: '40152' },
  { text: 'Banjercito', value: '37019' },
  { text: 'Bank of America', value: '40106' },
  { text: 'Bank of China', value: '40159' },
  { text: 'Bankaool', value: '40147' },
  { text: 'Banobras', value: '37009' },
  { text: 'Banorte', value: '40072' },
  { text: 'Banregio', value: '40058' },
  { text: 'Bansi', value: '40060' },
  { text: 'Barclays', value: '40129' },
  { text: 'BBASE', value: '40145' },
  { text: 'BBVA Bancomer', value: '40012' },
  { text: 'BMonex', value: '40112' },
  { text: 'Caja Pop Mexica', value: '90677' },
  { text: 'Caja Telefonist', value: '90683' },
  { text: 'Cashi Cuenta', value: '90715' },
  { text: 'Citi Mexico', value: '40124' },
  { text: 'Clip', value: '90730' },
  { text: 'Compartamos Banco', value: '40130' },
  { text: 'Consubanco', value: '40140' },
  { text: 'Coopdesarrollo', value: '90725' },
  { text: 'Credicapital', value: '90652' },
  { text: 'Crediclub', value: '90688' },
  { text: 'Cristobal Colon', value: '90680' },
  { text: 'Cuenca', value: '90723' },
  { text: 'Dep y Pag Dig', value: '90729' },
  { text: 'Donde', value: '40151' },
  { text: 'Finamex', value: '90616' },
  { text: 'Finco Pay', value: '90734' },
  { text: 'Fincomun', value: '90634' },
  { text: 'Fintoc', value: '90738' },
  { text: 'Fondeadora', value: '90699' },
  { text: 'Fondo (FIRA)', value: '90685' },
  { text: 'GBM', value: '90601' },
  { text: 'Hey Banco', value: '40167' },
  { text: 'Hipotecaria Fed', value: '37168' },
  { text: 'HSBC', value: '40021' },
  { text: 'ICBC', value: '40155' },
  { text: 'Indeval', value: '90902' },
  { text: 'Inmobiliario', value: '40150' },
  { text: 'Intercam Banco', value: '40136' },
  { text: 'Invex', value: '40059' },
  { text: 'JP Morgan', value: '40110' },
  { text: 'Kapital', value: '40128' },
  { text: 'Klar', value: '90661' },
  { text: 'Kuspit', value: '90653' },
  { text: 'Libertad', value: '90670' },
  { text: 'Masari', value: '90602' },
  { text: 'Mercado Pago W', value: '90722' },
  { text: 'MexPago', value: '90720' },
  { text: 'Mifel', value: '40042' },
  { text: 'Mizuho Bank', value: '40158' },
  { text: 'MonexCB', value: '90600' },
  { text: 'MUFG', value: '40108' },
  { text: 'Multiva Banco', value: '40132' },
  { text: 'NAFIN', value: '37135' },
  { text: 'Nubank', value: '40638' },
  { text: 'NVIO Pagos Mexico', value: '90710' },
  { text: 'Pagatodo', value: '40148' },
  { text: 'Peibo', value: '90732' },
  { text: 'PPBalanceMX', value: '90714' },
  { text: 'Profuturo', value: '90620' },
  { text: 'Revolut Bank', value: '40170' },
  { text: 'Sabadell', value: '40156' },
  { text: 'Santander', value: '40014' },
  { text: 'Scotiabank', value: '40044' },
  { text: 'Shinhan', value: '40157' },
  { text: 'Spin by OXXO', value: '90728' },
  { text: 'STP', value: '90646' },
  { text: 'Tesored', value: '90703' },
  { text: 'Transfer', value: '90684' },
  { text: 'Transfer Directo', value: '90727' },
  { text: 'TRF', value: '90631' },
  { text: 'UALA', value: '40138' },
  { text: 'Unagra', value: '90656' },
  { text: 'Valmex', value: '90617' },
  { text: 'Value', value: '90605' },
  { text: 'Ve por Mas', value: '40113' },
  { text: 'Volkswagen', value: '40141' }
];

/**
 * Códigos de propósito SWIFT por país, conforme BlindPay API.
 * Cada item: { text: 'Descrição legível', value: 'xx_swift_codigo' }
 * Prefixos: ae_, bh_, ch_, cn_, hk_, id_, in_, jp_, ke_, ph_, pk_, za_
 */
export const SWIFT_PAYMENT_CODE_OPTIONS = [
  // AE — Emirados Árabes
  { text: 'Turismo e Viagens', value: 'ae_swift_str' },
  { text: 'Serviços de Telecomunicação', value: 'ae_swift_tcs' },
  { text: 'Royalties / Propriedade Intelectual', value: 'ae_swift_ipc' },
  { text: 'Serviços de Informação', value: 'ae_swift_ifs' },
  { text: 'Transporte Marítimo', value: 'ae_swift_sts' },
  { text: 'Consultoria Profissional e de Gestão', value: 'ae_swift_pms' },
  { text: 'Serviços de Tecnologia da Informação', value: 'ae_swift_its' },
  { text: 'Exportação de Mercadorias (FOB)', value: 'ae_swift_gde' },
  { text: 'Outros Métodos de Transporte', value: 'ae_swift_ots' },
  { text: 'Serviços Técnicos, Comerciais e Outros', value: 'ae_swift_tts' },
  // BH — Bahrein
  { text: 'Depósito / Conta Bancária no Exterior (Residentes)', value: 'bh_swift_afa' },
  { text: 'Depósito / Conta Bancária no Bahrein (Não Residentes)', value: 'bh_swift_afl' },
  { text: 'Transporte Aéreo', value: 'bh_swift_ats' },
  { text: 'Investimento Direto no Exterior (Participação Societária)', value: 'bh_swift_cea' },
  { text: 'Investimento Direto no Bahrein (Participação Societária)', value: 'bh_swift_cel' },
  { text: 'Doações e Contribuições Filantrópicas', value: 'bh_swift_chc' },
  { text: 'Títulos de Dívida no Exterior (Longo Prazo)', value: 'bh_swift_dla' },
  { text: 'Empréstimos Intragrupo — Exterior', value: 'bh_swift_dlf' },
  { text: 'Títulos de Residentes em Não Relacionadas (Longo Prazo)', value: 'bh_swift_dll' },
  { text: 'Dividendos Não Intragrupo', value: 'bh_swift_doe' },
  { text: 'Títulos de Dívida no Exterior (Curto Prazo)', value: 'bh_swift_dsa' },
  { text: 'Títulos de Dívida Intragrupo Exterior', value: 'bh_swift_dsf' },
  { text: 'Títulos de Residentes em Não Relacionadas (Curto Prazo)', value: 'bh_swift_dsl' },
  { text: 'Remessa para Família / Remessas de Trabalhadores', value: 'bh_swift_fam' },
  { text: 'Derivativos Financeiros — Exterior', value: 'bh_swift_fda' },
  { text: 'Derivativos Financeiros — Bahrein', value: 'bh_swift_fdl' },
  { text: 'Cotas de Fundos de Investimento — Exterior', value: 'bh_swift_fia' },
  { text: 'Cotas de Fundos de Investimento — Bahrein', value: 'bh_swift_fil' },
  { text: 'Serviços Financeiros', value: 'bh_swift_fis' },
  { text: 'Participações Societárias no Exterior (Não Relacionadas)', value: 'bh_swift_fsa' },
  { text: 'Participações Societárias no Bahrein (Não Relacionadas)', value: 'bh_swift_fsl' },
  { text: 'Exportação de Mercadorias (FOB)', value: 'bh_swift_gde' },
  { text: 'Importação de Mercadorias (CIF)', value: 'bh_swift_gdi' },
  { text: 'Processamento, Reparo e Manutenção de Mercadorias', value: 'bh_swift_gms' },
  { text: 'Bens e Serviços Governamentais', value: 'bh_swift_gos' },
  { text: 'Receitas Governamentais (Impostos, Tarifas, Transferências)', value: 'bh_swift_gri' },
  { text: 'Serviços de Informação', value: 'bh_swift_ifs' },
  { text: 'Dividendos Intragrupo', value: 'bh_swift_igd' },
  { text: 'Juros sobre Dívida Intragrupo', value: 'bh_swift_iid' },
  { text: 'Serviços de Seguros', value: 'bh_swift_ins' },
  { text: 'Rendimentos sobre Depósitos', value: 'bh_swift_iod' },
  { text: 'Rendimentos sobre Empréstimos', value: 'bh_swift_iol' },
  { text: 'Royalties / Propriedade Intelectual', value: 'bh_swift_ipc' },
  { text: 'Rendimentos de Cotas de Fundos', value: 'bh_swift_ish' },
  { text: 'Juros sobre Títulos (Longo Prazo)', value: 'bh_swift_isl' },
  { text: 'Juros sobre Títulos (Curto Prazo)', value: 'bh_swift_iss' },
  { text: 'Serviços de Tecnologia da Informação', value: 'bh_swift_its' },
  { text: 'Empréstimos Intragrupo no Bahrein (Longo Prazo)', value: 'bh_swift_ldl' },
  { text: 'Títulos de Dívida Intragrupo no Bahrein', value: 'bh_swift_lds' },
  { text: 'Arrendamento no Exterior', value: 'bh_swift_lea' },
  { text: 'Arrendamento no Bahrein', value: 'bh_swift_lel' },
  { text: 'Empréstimos a Não Residentes (Longo Prazo)', value: 'bh_swift_lla' },
  { text: 'Empréstimos de Não Residentes a Residentes (Longo Prazo)', value: 'bh_swift_lll' },
  { text: 'Outros Métodos de Transporte', value: 'bh_swift_ots' },
  { text: 'Lucros sobre Produtos Islâmicos', value: 'bh_swift_pip' },
  { text: 'Consultoria Profissional e de Gestão', value: 'bh_swift_pms' },
  { text: 'Compra de Imóvel no Exterior', value: 'bh_swift_ppa' },
  { text: 'Compra de Imóvel no Bahrein', value: 'bh_swift_ppl' },
  { text: 'Lucros ou Aluguéis de Imóveis', value: 'bh_swift_prr' },
  { text: 'Serviços Pessoais, Culturais, Audiovisuais e Recreativos', value: 'bh_swift_prs' },
  { text: 'Títulos de Dívida Reversa no Exterior', value: 'bh_swift_rda' },
  { text: 'Títulos de Dívida Reversa no Bahrein', value: 'bh_swift_rdl' },
  { text: 'Pesquisa e Desenvolvimento', value: 'bh_swift_rds' },
  { text: 'Participações Societárias Reversas no Exterior', value: 'bh_swift_rea' },
  { text: 'Participações Societárias Reversas no Bahrein', value: 'bh_swift_rel' },
  { text: 'Repos sobre Títulos Estrangeiros', value: 'bh_swift_rfs' },
  { text: 'Repos sobre Títulos de Residentes', value: 'bh_swift_rls' },
  { text: 'Salário / Remuneração de Empregados', value: 'bh_swift_sal' },
  { text: 'Construção Civil', value: 'bh_swift_sco' },
  { text: 'Empréstimos a Não Residentes (Curto Prazo)', value: 'bh_swift_sla' },
  { text: 'Empréstimos de Não Residentes a Residentes (Curto Prazo)', value: 'bh_swift_sll' },
  { text: 'Turismo e Viagens', value: 'bh_swift_str' },
  { text: 'Transporte Marítimo', value: 'bh_swift_sts' },
  { text: 'Créditos Comerciais a Pagar', value: 'bh_swift_tcp' },
  { text: 'Créditos Comerciais a Receber', value: 'bh_swift_tcr' },
  { text: 'Serviços de Telecomunicação', value: 'bh_swift_tcs' },
  { text: 'Serviços Técnicos, Comerciais e Outros', value: 'bh_swift_tts' },
  // CH — Suíça
  { text: 'Doação Filantrópica', value: 'ch_swift_ccdndr' },
  { text: 'Transferência de Capital Transfronteiriça', value: 'ch_swift_cctfdr' },
  { text: 'Comércio de Mercadorias Transfronteiriço', value: 'ch_swift_cgoddr' },
  { text: 'Outras Transações de Conta Corrente', value: 'ch_swift_cocadr' },
  { text: 'Comércio de Serviços Transfronteiriço', value: 'ch_swift_cstrdr' },
  { text: 'Pagamento Transfronteiriço (Individual)', value: 'ch_swift_remtdr' },
  // CN — China
  { text: 'Conta de Capital — Pagamento/Dívida/Empréstimo', value: 'cn_swift_ccdndr' },
  { text: 'Transferência de Capital Transfronteiriça', value: 'cn_swift_cctfdr' },
  { text: 'Comércio de Mercadorias Transfronteiriço', value: 'cn_swift_cgoddr' },
  { text: 'Outras Transações de Conta Corrente', value: 'cn_swift_cocadr' },
  { text: 'Comércio de Serviços Transfronteiriço', value: 'cn_swift_cstrdr' },
  { text: 'Remessa — Pagamento Pessoal Não Comercial', value: 'cn_swift_remtdr' },
  // HK — Hong Kong
  { text: 'Doação Filantrópica', value: 'hk_swift_charitabledonation' },
  { text: 'Mercadorias', value: 'hk_swift_goods' },
  { text: 'Uso Pessoal', value: 'hk_swift_personal' },
  { text: 'Serviços', value: 'hk_swift_services' },
  // JP — Jordânia (prefixo jp_ na BlindPay)
  { text: 'Pagamento de Fatura / Compra', value: 'jp_swift_101' },
  { text: 'Pagamento de Conta de Utilidades', value: 'jp_swift_102' },
  { text: 'Recarga de Cartão Pré-pago', value: 'jp_swift_103' },
  { text: 'Ordens Permanentes', value: 'jp_swift_104' },
  { text: 'Doações Pessoais', value: 'jp_swift_105' },
  { text: 'Assistência e Despesas Familiares', value: 'jp_swift_106' },
  { text: 'Contribuição à Seguridade Social (Individual)', value: 'jp_swift_107' },
  { text: 'Mensalidades de Associações', value: 'jp_swift_108' },
  { text: 'Conta Poupança e Financiamento', value: 'jp_swift_109' },
  { text: 'Herança', value: 'jp_swift_110' },
  { text: 'Indenização de Rescisão', value: 'jp_swift_111' },
  { text: 'Cartão de Crédito — Pagamento', value: 'jp_swift_1111' },
  { text: 'Empréstimo Pessoal — Pagamento', value: 'jp_swift_1112' },
  { text: 'Salários — Setor Público', value: 'jp_swift_201' },
  { text: 'Salários — Trabalhadores', value: 'jp_swift_202' },
  { text: 'Salários — Setor Privado', value: 'jp_swift_203' },
  { text: 'Receitas de Investimento', value: 'jp_swift_301' },
  { text: 'Corretagem de Investimentos', value: 'jp_swift_302' },
  { text: 'Seguros', value: 'jp_swift_303' },
  { text: 'Investimento Local', value: 'jp_swift_305' },
  { text: 'Investimento Externo', value: 'jp_swift_306' },
  { text: 'Frete Aéreo', value: 'jp_swift_401' },
  { text: 'Frete Terrestre', value: 'jp_swift_402' },
  { text: 'Frete Marítimo', value: 'jp_swift_403' },
  { text: 'Turismo e Viagens', value: 'jp_swift_404' },
  { text: 'Exportação — Setor Público', value: 'jp_swift_601' },
  { text: 'Exportação — Setor Privado', value: 'jp_swift_602' },
  { text: 'Importação — Setor Público', value: 'jp_swift_603' },
  { text: 'Importação — Setor Privado', value: 'jp_swift_604' },
  { text: 'Serviços de Telecomunicação', value: 'jp_swift_801' },
  { text: 'Serviços Financeiros', value: 'jp_swift_802' },
  { text: 'Serviços de Tecnologia da Informação', value: 'jp_swift_803' },
  { text: 'Consultoria', value: 'jp_swift_804' },
  { text: 'Construção Civil', value: 'jp_swift_805' },
  { text: 'Manutenção e Montagem', value: 'jp_swift_806' },
  { text: 'Marketing e Mídia', value: 'jp_swift_807' },
  { text: 'Serviços Médicos e de Saúde', value: 'jp_swift_809' },
  { text: 'Serviços Culturais, Educacionais e de Entretenimento', value: 'jp_swift_810' },
  { text: 'Aluguel', value: 'jp_swift_811' },
  { text: 'Imóveis', value: 'jp_swift_812' },
  { text: 'Impostos e Taxas', value: 'jp_swift_813' },
  { text: 'Comissões', value: 'jp_swift_815' },
  { text: 'Fundos Governamentais', value: 'jp_swift_902' },
  { text: 'Fundos do Setor Privado', value: 'jp_swift_903' },
  { text: 'Fundos Recebidos do Exterior', value: 'jp_swift_904' },
  { text: 'Remessas de Comunidades Internacionais e Embaixadas', value: 'jp_swift_1001' },
  { text: 'Missões Diplomáticas Permanentes', value: 'jp_swift_1002' },
  { text: 'Missões Diplomáticas Temporárias', value: 'jp_swift_1003' },
  { text: 'Receitas de Embaixadas Jordanianas', value: 'jp_swift_1004' },
  { text: 'Parcelas de Empréstimos de Longo Prazo — Setor Público', value: 'jp_swift_1101' },
  { text: 'Juros de Empréstimos de Longo Prazo — Setor Público', value: 'jp_swift_1102' },
  { text: 'Parcelas de Empréstimos de Curto Prazo — Setor Público', value: 'jp_swift_1103' },
  { text: 'Juros de Empréstimos de Curto Prazo — Setor Público', value: 'jp_swift_1104' },
  { text: 'Parcelas de Empréstimos de Longo Prazo — Setor Privado', value: 'jp_swift_1105' },
  { text: 'Juros de Empréstimos de Longo Prazo — Setor Público (Privado)', value: 'jp_swift_1106' },
  { text: 'Parcelas de Empréstimos de Curto Prazo — Setor Privado', value: 'jp_swift_1107' },
  { text: 'Juros de Empréstimos de Curto Prazo — Setor Privado', value: 'jp_swift_1108' },
  { text: 'Parcelas de Empréstimos com Garantia Governamental', value: 'jp_swift_1109' },
  { text: 'Juros de Empréstimos com Garantia Governamental', value: 'jp_swift_1110' },
  { text: 'Reencaminhamento / Rerouting', value: 'jp_swift_1201' },
  { text: 'Apoio à Pesquisa Científica', value: 'jp_swift_1202' },
  { text: 'Salários do Corpo Diplomático Jordaniano', value: 'jp_swift_204' },
  { text: 'Salários do Corpo Diplomático Estrangeiro', value: 'jp_swift_205' },
  { text: 'Salários Recebidos do Exterior', value: 'jp_swift_206' },
  { text: 'Aposentadoria Civil / Militar', value: 'jp_swift_207' },
  { text: 'Aposentadoria pela Seguridade Social', value: 'jp_swift_208' },
  { text: 'Contribuição Previdenciária de Empresa', value: 'jp_swift_209' },
  { text: 'Assinaturas a Organizações Internacionais Não Monetárias', value: 'jp_swift_304' },
  { text: 'Garantia de Participação em Licitação (Tender Bond)', value: 'jp_swift_307' },
  { text: 'Transferências de Delegações Governamentais', value: 'jp_swift_501' },
  { text: 'Transferências de Delegações do Setor Privado', value: 'jp_swift_502' },
  { text: 'Educação Governamental', value: 'jp_swift_503' },
  { text: 'Educação — Setor Privado', value: 'jp_swift_504' },
  { text: 'Auxílio a Comunidades Religiosas', value: 'jp_swift_701' },
  { text: 'Auxílio a Comunidades Internacionais', value: 'jp_swift_702' },
  { text: 'Auxílio a Comunidades Árabes', value: 'jp_swift_703' },
  { text: 'Auxílio da ONU', value: 'jp_swift_704' },
  { text: 'Auxílio de Comunidades Beneficentes', value: 'jp_swift_705' },
  { text: 'Serviços de Mineração', value: 'jp_swift_808' },
  { text: 'Taxas e Tarifas', value: 'jp_swift_814' },
  { text: 'Taxas de Franquia e Licença', value: 'jp_swift_816' },
  { text: 'Cobrança de Cheques', value: 'jp_swift_817' },
  { text: 'Taxas de Associação / Anuidade', value: 'jp_swift_818' },
  { text: 'Fundos Municipais', value: 'jp_swift_901' },
  // KE — Quênia
  { text: 'Transporte Aéreo', value: 'ke_swift_airb' },
  { text: 'Contribuições Filantrópicas / Caridade', value: 'ke_swift_chc' },
  { text: 'Desenvolvimento Comunitário', value: 'ke_swift_comu' },
  { text: 'Construção Civil', value: 'ke_swift_cons' },
  { text: 'Liquidação de Operação Comercial', value: 'ke_swift_cort' },
  { text: 'Pagamento de Dividendos', value: 'ke_swift_divd' },
  { text: 'Despesas com Educação', value: 'ke_swift_educ' },
  { text: 'Câmbio / Moeda Estrangeira', value: 'ke_swift_foex' },
  { text: 'Pagamentos Governamentais', value: 'ke_swift_govt' },
  { text: 'Alimentos e Bens de Consumo', value: 'ke_swift_hlfd' },
  { text: 'Plano de Saúde', value: 'ke_swift_hlti' },
  { text: 'Empréstimo', value: 'ke_swift_loan' },
  { text: 'Serviços Médicos', value: 'ke_swift_mdcs' },
  { text: 'Mercadorias e Produtos Manufaturados', value: 'ke_swift_merc' },
  { text: 'Pagamento de Salário (PAYE)', value: 'ke_swift_paye' },
  { text: 'Serviço Profissional / Comissão', value: 'ke_swift_psco' },
  { text: 'Reembolso', value: 'ke_swift_refu' },
  { text: 'Aluguel de Imóvel', value: 'ke_swift_rent' },
  { text: 'Pagamento de Salário', value: 'ke_swift_sala' },
  { text: 'Poupança', value: 'ke_swift_savg' },
  { text: 'Taxa Escolar', value: 'ke_swift_scho' },
  { text: 'Frete Marítimo', value: 'ke_swift_ship' },
  { text: 'Pagamento de Imposto', value: 'ke_swift_taxs' },
  { text: 'Conta de Utilidades', value: 'ke_swift_ubil' },
  { text: 'Pagamento de IVA', value: 'ke_swift_vatx' },
  { text: 'Retenção na Fonte', value: 'ke_swift_whld' },
  { text: 'Imposto de Importação — Petróleo', value: 'ke_swift_1001' },
  { text: 'Imposto de Importação', value: 'ke_swift_1002' },
  { text: 'Imposto de Consumo — Petróleo', value: 'ke_swift_1101' },
  { text: 'Imposto de Consumo (Excise Duty)', value: 'ke_swift_1102' },
  { text: 'IVA — Petróleo', value: 'ke_swift_1201' },
  { text: 'IVA — Importações', value: 'ke_swift_1202' },
  { text: 'IVA — Petróleo (8%)', value: 'ke_swift_1206' },
  { text: 'Taxa de Alteração', value: 'ke_swift_1501' },
  { text: 'Taxa de Concessão', value: 'ke_swift_1518' },
  { text: 'Taxas de Registro', value: 'ke_swift_1519' },
  { text: 'Taxa de Transbordo (Transshipment)', value: 'ke_swift_1527' },
  { text: 'Taxas IDF (2,0%)', value: 'ke_swift_1801' },
  { text: 'IDF / PIF — Petróleo', value: 'ke_swift_1802' },
  { text: 'Aluguel de Armazém Alfandegário', value: 'ke_swift_1908' },
  { text: 'Levy de Manutenção de Estradas (RML)', value: 'ke_swift_2101' },
  { text: 'Levy de Regulação do Setor de Petróleo (PRL)', value: 'ke_swift_2301' },
  { text: 'Pagamento Bruto — Fundo de Desenvolvimento do Petróleo (PDF)', value: 'ke_swift_2501' },
  { text: 'Imposto de Renda — PAYE', value: 'ke_swift_2901' },
  { text: 'Imposto de Renda — Empresas', value: 'ke_swift_3001' },
  { text: 'Imposto de Renda — Pessoa Física Residente', value: 'ke_swift_3100' },
  { text: 'Imposto Mensal sobre Receita de Aluguel', value: 'ke_swift_3101' },
  { text: 'Retenção na Fonte — Receita de Aluguel', value: 'ke_swift_3103' },
  { text: 'Imposto de Renda — Retenção na Fonte', value: 'ke_swift_3200' },
  { text: 'Imposto Antecipado sobre Veículos', value: 'ke_swift_3304' },
  { text: 'IVA — Retenção na Fonte', value: 'ke_swift_3509' },
  { text: 'IVA — Imposto sobre Valor Agregado', value: 'ke_swift_3514' },
  { text: 'Levy de Padrões (Standards Levy)', value: 'ke_swift_3801' },
  { text: 'Imposto de Selo (Stamp Duty)', value: 'ke_swift_4103' },
  { text: 'Secretaria de Pesca, Aquicultura e Economia Azul', value: 'ke_swift_4301' },
  { text: 'Certificado de Saúde de Importação', value: 'ke_swift_4601' },
  { text: 'Formulário de Declaração de Importação — Nozes e Óleos', value: 'ke_swift_4702' },
  { text: 'Autoridade Nacional de Treinamento Industrial (NITA)', value: 'ke_swift_512' },
  { text: 'Levy de Desenvolvimento Ferroviário do Quênia (RDL)', value: 'ke_swift_6001' },
  { text: 'Levy de Desenvolvimento Ferroviário do Quênia (RDL) — Petróleo', value: 'ke_swift_6002' },
  { text: 'Venda de Placa de Veículo (Unitária)', value: 'ke_swift_6101' },
  { text: 'Venda de Par de Placas de Veículo', value: 'ke_swift_6102' },
  { text: 'Taxa de Transferência de Registro de Veículo', value: 'ke_swift_6301' },
  { text: 'Levy do Superintendente de Navegação Mercante', value: 'ke_swift_6401' },
  { text: 'Levy do Superintendente de Navegação Mercante (MSS) — Petróleo', value: 'ke_swift_6402' },
  { text: 'Fundo de Segurança Rodoviária', value: 'ke_swift_6501' },
  { text: 'Imposto de Compra SHMV', value: 'ke_swift_6601' },
  { text: 'Imposto Antecipado (Advance Tax)', value: 'ke_swift_adtx' },
  { text: 'Receita de Agência (incl. Imposto de Selo, Apostas)', value: 'ke_swift_artx' },
  { text: 'Benefício por Filho (Child Benefit)', value: 'ke_swift_bech' },
  { text: 'Departamento de Supervisão Bancária (BSD)', value: 'ke_swift_bsd' },
  { text: 'Imposto sobre Apostas (Betting Tax)', value: 'ke_swift_bttx' },
  { text: 'Chamadas de Margem — Colateral em Dinheiro', value: 'ke_swift_ccmc' },
  { text: 'Cerimônias (Funeral, Formatura, Casamento)', value: 'ke_swift_cere' },
  { text: 'CFR — Custo e Frete (Transporte Marítimo / Aquaviário) — Incoterms 2010', value: 'ke_swift_cfr' },
  { text: 'Imposto sobre Ganho de Capital (CGT)', value: 'ke_swift_cgtx' },
  { text: 'Despesas com Vestuário', value: 'ke_swift_clot' },
  { text: 'Identificação Fiscal de Empresa (Corporate Tax ID)', value: 'ke_swift_cotx' },
  { text: 'Pagamentos ao Depositário Central de Valores Mobiliários (CSD)', value: 'ke_swift_csdk' },
  { text: 'Imposto de Consumo (Excise Duty)', value: 'ke_swift_edtx' },
  { text: 'Agropecuária', value: 'ke_swift_farm' },
  { text: 'Despesas com Combustível', value: 'ke_swift_fuel' },
  { text: 'Pagamentos e Transferências Governamentais', value: 'ke_swift_gokx' },
  { text: 'Férias / Turismo', value: 'ke_swift_holi' },
  { text: 'Pagamento de Empréstimo / Depósito Interbancário', value: 'ke_swift_ibld' },
  { text: 'Prêmio de Seguro Automotivo', value: 'ke_swift_inpc' },
  { text: 'Prêmio de Seguro', value: 'ke_swift_insu' },
  { text: 'Juros', value: 'ke_swift_inte' },
  { text: 'Imposto de Renda', value: 'ke_swift_intx' },
  { text: 'Investimentos e Títulos Financeiros', value: 'ke_swift_invs' },
  { text: 'Imposto Parcelado (Installment Tax)', value: 'ke_swift_istx' },
  { text: 'Taxa de Licença', value: 'ke_swift_licf' },
  { text: 'Seguro de Vida', value: 'ke_swift_lifi' },
  { text: 'Equipamentos e Maquinários', value: 'ke_swift_mach' },
  { text: 'Contribuição ao Fundo de Auxílio Médico (MAFC)', value: 'ke_swift_mafc' },
  { text: 'Multas e Penalidades', value: 'ke_swift_pena' },
  { text: 'Taxa de Licença — Bancos Comerciais', value: 'ke_swift_pl39' },
  { text: 'Taxa de Licença — Instituições de Microcrédito com Depósito', value: 'ke_swift_pl40' },
  { text: 'Taxa de Licença — Casas de Câmbio (Forex Bureaus)', value: 'ke_swift_pl41' },
  { text: 'Taxa de Licença — Agências de Referência de Crédito', value: 'ke_swift_pl42' },
  { text: 'Taxa de Licença — Instituições Financeiras Hipotecárias', value: 'ke_swift_pl43' },
  { text: 'Taxa de Solicitação — Bancos Comerciais', value: 'ke_swift_pl44' },
  { text: 'Taxa de Solicitação — Instituições Financeiras Hipotecárias', value: 'ke_swift_pl45' },
  { text: 'Taxa de Solicitação — Instituições com Depósito', value: 'ke_swift_pl46' },
  { text: 'Taxa de Solicitação — Casas de Câmbio (Forex Bureaus)', value: 'ke_swift_pl47' },
  { text: 'Taxa de Solicitação — Agências de Referência de Crédito', value: 'ke_swift_pl48' },
  { text: 'Penalidade — Bancos Comerciais', value: 'ke_swift_pl49' },
  { text: 'Penalidade — Instituições Financeiras Hipotecárias', value: 'ke_swift_pl50' },
  { text: 'Penalidade — Instituições de Microcrédito com Depósito', value: 'ke_swift_pl51' },
  { text: 'Penalidade — Casas de Câmbio (Forex Bureaus)', value: 'ke_swift_pl52' },
  { text: 'Penalidade — Agências de Referência de Crédito', value: 'ke_swift_pl53' },
  { text: 'Seguro Patrimonial', value: 'ke_swift_ppti' },
  { text: 'Compra de Imóvel', value: 'ke_swift_prpy' },
  { text: 'Atividades Religiosas', value: 'ke_swift_relg' },
  { text: 'Imposto sobre Receita de Aluguel', value: 'ke_swift_ritx' },
  { text: 'Ferrovia / Transporte Ferroviário', value: 'ke_swift_rlwy' },
  { text: 'Imposto de Selo', value: 'ke_swift_sdtx' },
  { text: 'Sweeps / Financiamento de Liquidez', value: 'ke_swift_swlf' },
  { text: 'Reembolso de Imposto', value: 'ke_swift_taxr' },
  { text: 'Conta de Telecomunicações', value: 'ke_swift_tbil' },
  { text: 'Dízimo e Ofertas', value: 'ke_swift_tith' },
  { text: 'Imposto sobre Faturamento (Turnover Tax)', value: 'ke_swift_totx' },
  { text: 'Removido do Rastreamento', value: 'ke_swift_trac' },
  { text: 'Placa de Identificação de Veículo (VIPN)', value: 'ke_swift_vipn' },
  // ZA — África do Sul
  { text: 'Mercadorias — Liquidações Comerciais', value: 'za_swift_105' },
  { text: 'Turismo e Viagens', value: 'za_swift_220' },
  { text: 'Seguros e Previdência', value: 'za_swift_231' },
  { text: 'Serviços de Construção', value: 'za_swift_242' },
  { text: 'Serviços de Telecomunicação', value: 'za_swift_250' },
  { text: 'Correio e Encomendas', value: 'za_swift_251' },
  { text: 'Serviços de Computação', value: 'za_swift_265' },
  { text: 'Serviços de Informação', value: 'za_swift_266' },
  { text: 'Royalties / Propriedade Intelectual', value: 'za_swift_275' },
  { text: 'Pesquisa e Desenvolvimento', value: 'za_swift_276' },
  { text: 'Serviços de Leasing Operacional', value: 'za_swift_280' },
  { text: 'Consultoria Jurídica, Contábil e de Gestão', value: 'za_swift_285' },
  { text: 'Outros Serviços Empresariais', value: 'za_swift_287' },
  { text: 'Manutenção e Reparos', value: 'za_swift_288' },
  { text: 'Arquitetura, Engenharia e Serviços Técnicos', value: 'za_swift_289' },
  { text: 'Serviços Pessoais, Culturais e Recreativos', value: 'za_swift_290' },
  { text: 'Serviços Audiovisuais', value: 'za_swift_291' },
  { text: 'Serviços de Intermediação Comercial', value: 'za_swift_296' },
  { text: 'Outros Serviços Empresariais Diversos', value: 'za_swift_297' },
  { text: 'Turismo Pessoal / Férias', value: 'za_swift_308' },
  { text: 'Remuneração de Empregados / Rendimentos de Investimentos', value: 'za_swift_401' },
  { text: 'Transferências de Capital — Perdão de Dívida', value: 'za_swift_10101' },
  { text: 'Transferências de Capital — Imigrantes', value: 'za_swift_10301' },
  { text: 'Outras Transferências de Capital', value: 'za_swift_27201' },
  // IN — Índia
  { text: 'Repatriação — Portfólio Indiano no Exterior (Ações)', value: 'in_swift_p0001' },
  { text: 'Repatriação — Portfólio Indiano no Exterior (Títulos de Dívida)', value: 'in_swift_p0002' },
  { text: 'Repatriação — Investimento Direto Indiano no Exterior (Ações)', value: 'in_swift_p0003' },
  { text: 'Repatriação — Investimento Direto Indiano no Exterior (Títulos de Dívida)', value: 'in_swift_p0004' },
  { text: 'Repatriação — Investimento Indiano no Exterior (Imóveis)', value: 'in_swift_p0005' },
  { text: 'Investimento Direto Estrangeiro na Índia (Ações)', value: 'in_swift_p0006' },
  { text: 'Investimento Direto Estrangeiro na Índia (Títulos de Dívida)', value: 'in_swift_p0007' },
  { text: 'Investimento Direto Estrangeiro na Índia (Imóveis)', value: 'in_swift_p0008' },
  { text: 'Investimento de Portfólio Estrangeiro na Índia (Ações)', value: 'in_swift_p0009' },
  { text: 'Investimento de Portfólio Estrangeiro na Índia (Títulos de Dívida)', value: 'in_swift_p0010' },
  { text: 'Pagamento de Empréstimos a Não Residentes', value: 'in_swift_p0011' },
  { text: 'Empréstimos de Longo e Médio Prazo de Não Residentes para a Índia (ECB)', value: 'in_swift_p0012' },
  { text: 'Empréstimos de Curto Prazo de Não Residentes para a Índia (Crédito Comercial)', value: 'in_swift_p0013' },
  { text: 'Depósitos de Não Residentes — FCNR(B)/NR(E)RA', value: 'in_swift_p0014' },
  { text: 'Empréstimos e Descobertos Bancários — Conta Própria (ADs)', value: 'in_swift_p0015' },
  { text: 'Compra de Moeda Estrangeira contra Outra Moeda', value: 'in_swift_p0016' },
  { text: 'Venda de Ativos Não Produzidos Não Financeiros — Governo (Patentes, Imóveis, Recursos Naturais)', value: 'in_swift_p0017' },
  { text: 'Derivativos Financeiros — Margem, Prêmio e Liquidação', value: 'in_swift_p0019' },
  { text: 'Venda de Ações sob Plano de Opção de Empregado (ESOP)', value: 'in_swift_p0020' },
  { text: 'Outros Investimentos — ADRs/GDRs', value: 'in_swift_p0021' },
  { text: 'Assistência Externa Recebida pela Índia — Empréstimos Multilaterais e Bilaterais', value: 'in_swift_p0022' },
  { text: 'Transferências de Capital — Governo (Garantias, Grants de Investimento)', value: 'in_swift_p0024' },
  { text: 'Transferências de Capital — Não Governo (Garantias, Grants de Investimento)', value: 'in_swift_p0025' },
  { text: 'Realização de Cobranças de Exportação (Valor Integral da Fatura)', value: 'in_swift_p0028' },
  { text: 'Adiantamentos Recebidos contra Contratos de Exportação', value: 'in_swift_p0029' },
  { text: 'Pesquisa de Mercado e Pesquisa de Opinião Pública', value: 'in_swift_p0099' },
  { text: 'Serviços de Mineração e Processamento de Minérios', value: 'in_swift_p0101' },
  { text: 'Serviços de Agente Comissionado', value: 'in_swift_p0102' },
  { text: 'Comércio Atacadista e Varejista', value: 'in_swift_p0103' },
  { text: 'Leasing Operacional sem Tripulação — Fretamento', value: 'in_swift_p0104' },
  { text: 'Outros Serviços Técnicos — Científicos e Espaciais', value: 'in_swift_p0105' },
  { text: 'Serviços Audiovisuais — Produção, Distribuição e Exibição Cinematográfica', value: 'in_swift_p0107' },
  { text: 'Produção, Distribuição e Transmissão de Rádio e Televisão', value: 'in_swift_p0108' },
  { text: 'Serviços de Entretenimento', value: 'in_swift_p0109' },
  // ID — Indonésia
  { text: 'Exportação de Mercadorias', value: 'id_swift_2011' },
  { text: 'Importação de Mercadorias', value: 'id_swift_2012' },
  { text: 'Combustível e Mantimentos (Bunkers & Stores)', value: 'id_swift_2015' },
  { text: 'Pagamento Antecipado — Export/Import (Integral)', value: 'id_swift_2018' },
  { text: 'Pagamento Antecipado — Export/Import (Parcial)', value: 'id_swift_2019' },
  { text: 'Transação Comercial Não Export/Import — Indonésia', value: 'id_swift_2097' },
  { text: 'Transação Comercial Não Export/Import — Exterior', value: 'id_swift_2098' },
  { text: 'Liquidação de Saldos (Netting) — Relacionada a Exportação', value: 'id_swift_2127' },
  { text: 'Liquidação de Saldos (Netting) — Não Relacionada a Exportação', value: 'id_swift_2129' },
  { text: 'Remessa de Renda de Trabalhadores', value: 'id_swift_2150' },
  { text: 'Renda de Trabalhadores', value: 'id_swift_2163' },
  { text: 'Compra e Venda de Ativos de Marketing Não Financeiros', value: 'id_swift_2193' },
  { text: 'Compra e Venda de Contratos, Leasing e Licenças Não Financeiras', value: 'id_swift_2194' },
  { text: 'Compra e Venda de Terrenos', value: 'id_swift_2197' },
  { text: 'Compra e Venda de Imóveis / Edificações', value: 'id_swift_2198' },
  { text: 'Investimento de Capital na Indonésia', value: 'id_swift_2203' },
  { text: 'Investimento de Capital no Exterior', value: 'id_swift_2204' },
  { text: 'Desinvestimento de Capital na Indonésia', value: 'id_swift_2206' },
  { text: 'Desinvestimento de Capital no Exterior', value: 'id_swift_2207' },
  { text: 'Concessão/Saque de Empréstimo — Até 1 Ano', value: 'id_swift_2221' },
  { text: 'Concessão/Saque de Empréstimo — Acima de 1 Ano', value: 'id_swift_2222' },
  { text: 'Pagamento de Empréstimo — Até 1 Ano', value: 'id_swift_2231' },
  { text: 'Pagamento de Empréstimo — Acima de 1 Ano', value: 'id_swift_2232' },
  { text: 'Arrendamento Financeiro (Leasing)', value: 'id_swift_2233' },
  { text: 'Depósito a Prazo na Indonésia — Até 3 Meses', value: 'id_swift_2240' },
  { text: 'Outros Depósitos na Indonésia — Conta Corrente e Call Money até 3 Meses', value: 'id_swift_2241' },
  { text: 'Depósito na Indonésia — 3 a 6 Meses', value: 'id_swift_2242' },
  { text: 'Depósito na Indonésia — Acima de 6 Meses', value: 'id_swift_2243' },
  { text: 'Resgate de Depósito a Prazo na Indonésia — Até 3 Meses', value: 'id_swift_2244' },
  { text: 'Resgate de Outros Depósitos na Indonésia — Conta Corrente e Call Money até 3 Meses', value: 'id_swift_2245' },
  { text: 'Resgate de Depósito na Indonésia — 3 a 6 Meses', value: 'id_swift_2246' },
  { text: 'Resgate de Depósito na Indonésia — Acima de 6 Meses', value: 'id_swift_2247' },
  { text: 'Depósito Offshore — Conta Corrente e Call Money até 3 Meses', value: 'id_swift_2251' },
  { text: 'Depósito Offshore — Conta Corrente e Call Money acima de 3 Meses', value: 'id_swift_2252' },
  { text: 'Resgate de Depósito Offshore — Conta Corrente e Call Money até 3 Meses', value: 'id_swift_2255' },
  { text: 'Resgate de Depósito Offshore — Conta Corrente e Call Money acima de 3 Meses', value: 'id_swift_2256' },
  { text: 'Saque de Câmbio de Conta Offshore', value: 'id_swift_2257' },
  { text: 'Câmbio Spot — Moeda Estrangeira vs. Rupia', value: 'id_swift_2261' },
  { text: 'Câmbio Spot — Moeda Estrangeira vs. Outra Moeda', value: 'id_swift_2262' },
  { text: 'Câmbio Forward — Moeda Estrangeira vs. Rupia', value: 'id_swift_2263' },
  { text: 'Câmbio Forward — Moeda Estrangeira vs. Outra Moeda', value: 'id_swift_2264' },
  { text: 'Derivativo — Lucro em Forward ou Similar', value: 'id_swift_2271' },
  { text: 'Derivativo — Recebível em Acordo de Taxa Forward (FRA)', value: 'id_swift_2272' },
  { text: 'Derivativo — Recebível em Swap de Juros ou Swap de Moeda', value: 'id_swift_2273' },
  { text: 'Derivativo — Margem Inicial/Reembolsável', value: 'id_swift_2274' },
  { text: 'Derivativo — Margem de Variação/Não Reembolsável', value: 'id_swift_2275' },
  { text: 'Derivativo — Prêmio Recebível em Opções', value: 'id_swift_2276' },
  { text: 'Derivativo — Principal Recebível na 1ª Perna do Swap de Moeda', value: 'id_swift_2277' },
  { text: 'Derivativo — Principal Recebível na Última Perna do Swap de Moeda', value: 'id_swift_2278' },
  { text: 'Derivativo — Prêmio Recebível em Credit Default Swap (CDS)', value: 'id_swift_2279' },
  { text: 'Depósito/Devolução de Garantia (Collateral)', value: 'id_swift_2280' },
  { text: 'Reembolso — Transação Não Export/Import', value: 'id_swift_2282' },
  { text: 'Outras Transações de Capital/Financeiras', value: 'id_swift_2299' },
  { text: 'Ações — Emitidas por Não Residente', value: 'id_swift_2311' },
  { text: 'Títulos de Dívida (Bonds) — Não Residente, acima de 1 Ano', value: 'id_swift_2321' },
  { text: 'Medium Term Notes (MTNs) — Não Residente, acima de 1 Ano', value: 'id_swift_2322' },
  { text: 'Outros Títulos de Longo Prazo — Não Residente, acima de 1 Ano', value: 'id_swift_2323' },
  { text: 'Letras do Tesouro (Treasury Bills) — Não Residente, até 1 Ano', value: 'id_swift_2331' },
  { text: 'Notas Promissórias (PNs/Promes) — Não Residente, até 1 Ano', value: 'id_swift_2332' },
  { text: 'Outros Títulos de Curto Prazo — Não Residente, até 1 Ano', value: 'id_swift_2333' },
  { text: 'Ações — Emitidas por Residente', value: 'id_swift_2341' },
  { text: 'Outros Títulos de Patrimônio (Warrant, Right) — Residente', value: 'id_swift_2342' },
  { text: 'Títulos Públicos (Government Bonds) — Residente, acima de 1 Ano', value: 'id_swift_2351' },
  { text: 'Debêntures Corporativas — Residente, acima de 1 Ano', value: 'id_swift_2352' },
  { text: 'Medium Term Notes (MTNs) — Residente, acima de 1 Ano', value: 'id_swift_2353' },
  { text: 'Outros Títulos de Longo Prazo — Residente, acima de 1 Ano', value: 'id_swift_2354' },
  { text: 'SBI / SWBI (Certificados Banco da Indonésia) — até 1 Ano', value: 'id_swift_2361' },
  { text: 'SPN (Letras do Tesouro Nacional Indonésio) — até 1 Ano', value: 'id_swift_2362' },
  { text: 'Notas Promissórias (PNs/Promes) — Residente, até 1 Ano', value: 'id_swift_2363' },
  { text: 'Certificados de Depósito Negociáveis (NCD) — Residente, até 1 Ano', value: 'id_swift_2364' },
  { text: 'Outros Títulos de Curto Prazo — Residente, até 1 Ano', value: 'id_swift_2365' },
  { text: 'Certificado de Depósito do Banco da Indonésia — até 1 Ano', value: 'id_swift_2366' },
  { text: 'Fundos de Investimento (Reksadana)', value: 'id_swift_2371' },
  { text: 'Fundos de Investimento Negociados (Reksadana)', value: 'id_swift_2372' },
  { text: 'Venda de Títulos Residentes com Repo — Proprietário, até 1 Ano', value: 'id_swift_2375' },
  { text: 'Venda de Títulos Residentes com Repo — Proprietário, acima de 1 Ano', value: 'id_swift_2376' },
  { text: 'Revenda de Títulos Residentes com Repo — Comprador, até 1 Ano', value: 'id_swift_2377' },
  { text: 'Revenda de Títulos Residentes com Repo — Comprador, acima de 1 Ano', value: 'id_swift_2378' },
  { text: 'Recompra de Títulos Residentes com Repo — Proprietário, até 1 Ano', value: 'id_swift_2379' },
  { text: 'Recompra de Títulos Residentes com Repo — Proprietário, acima de 1 Ano', value: 'id_swift_2380' },
  { text: 'Compra de Títulos Residentes com Repo — até 1 Ano', value: 'id_swift_2381' },
  { text: 'Compra de Títulos Residentes com Repo — acima de 1 Ano', value: 'id_swift_2382' },
  { text: 'Factoring com Banco na Indonésia — até 1 Ano', value: 'id_swift_2383' },
  { text: 'Factoring com Banco na Indonésia — acima de 1 Ano', value: 'id_swift_2384' },
  { text: 'Factoring com Empresa na Indonésia — até 1 Ano', value: 'id_swift_2385' },
  { text: 'Factoring com Empresa na Indonésia — acima de 1 Ano', value: 'id_swift_2386' },
  { text: 'Factoring com Banco no Exterior — até 1 Ano', value: 'id_swift_2387' },
  { text: 'Factoring com Banco no Exterior — acima de 1 Ano', value: 'id_swift_2388' },
  { text: 'Factoring com Empresa no Exterior — até 1 Ano', value: 'id_swift_2389' },
  { text: 'Factoring com Empresa no Exterior — acima de 1 Ano', value: 'id_swift_2390' },
  { text: 'Gold Swap — Pagamento pelo Provedor de Caixa, até 1 Ano', value: 'id_swift_2391' },
  { text: 'Gold Swap — Pagamento pelo Provedor de Caixa, acima de 1 Ano', value: 'id_swift_2392' },
  { text: 'Gold Swap — Devolução pelo Proprietário do Ouro, até 1 Ano', value: 'id_swift_2393' },
  { text: 'Gold Swap — Devolução pelo Proprietário do Ouro, acima de 1 Ano', value: 'id_swift_2394' },
  { text: 'Gold Swap — Recebimento pelo Provedor de Caixa, até 1 Ano', value: 'id_swift_2395' },
  { text: 'Gold Swap — Recebimento pelo Provedor de Caixa, acima de 1 Ano', value: 'id_swift_2396' },
  { text: 'Gold Swap — Recebimento pelo Proprietário do Ouro, até 1 Ano', value: 'id_swift_2397' },
  { text: 'Gold Swap — Recebimento pelo Proprietário do Ouro, acima de 1 Ano', value: 'id_swift_2398' },
  { text: 'Processamento de Mercadorias', value: 'id_swift_2400' },
  { text: 'Manutenção e Reparo de Mercadorias', value: 'id_swift_2405' },
  { text: 'Transporte de Passageiros — Marítimo', value: 'id_swift_2411' },
  { text: 'Transporte de Passageiros — Aéreo', value: 'id_swift_2412' },
  { text: 'Transporte de Passageiros — Outros Modais', value: 'id_swift_2413' },
  { text: 'Frete Export/Import — Marítimo', value: 'id_swift_2421' },
  { text: 'Frete Export/Import — Aéreo', value: 'id_swift_2422' },
  { text: 'Frete Export/Import — Outros Modais', value: 'id_swift_2423' },
  { text: 'Frete Não Export/Import — Marítimo', value: 'id_swift_2431' },
  { text: 'Frete Não Export/Import — Aéreo', value: 'id_swift_2432' },
  { text: 'Frete Não Export/Import — Outros Modais', value: 'id_swift_2433' },
  { text: 'Serviços Auxiliares de Transporte — Marítimo', value: 'id_swift_2441' },
  { text: 'Serviços Auxiliares de Transporte — Aéreo', value: 'id_swift_2442' },
  { text: 'Serviços Auxiliares de Transporte — Outros Modais', value: 'id_swift_2443' },
  { text: 'Correios e Encomendas', value: 'id_swift_2450' },
  { text: 'Viagem Corporativa', value: 'id_swift_2461' },
  { text: 'Viagem Pessoal', value: 'id_swift_2462' },
  { text: 'Serviços de Saúde na Indonésia', value: 'id_swift_2466' },
  { text: 'Serviços de Saúde no Exterior', value: 'id_swift_2467' },
  { text: 'Educação / Treinamento na Indonésia', value: 'id_swift_2468' },
  { text: 'Educação / Treinamento no Exterior', value: 'id_swift_2469' },
  { text: 'Serviços de Telecomunicação', value: 'id_swift_2480' },
  { text: 'Serviços de Tecnologia da Informação', value: 'id_swift_2490' },
  { text: 'Serviços de Informação', value: 'id_swift_2495' },
  { text: 'Construção Civil na Indonésia — até 1 Ano', value: 'id_swift_2501' },
  { text: 'Construção Civil na Indonésia — acima de 1 Ano', value: 'id_swift_2502' },
  { text: 'Construção Civil no Exterior — até 1 Ano', value: 'id_swift_2511' },
  { text: 'Construção Civil no Exterior — acima de 1 Ano', value: 'id_swift_2512' },
  { text: 'Seguro de Vida Direto — Prêmio', value: 'id_swift_2521' },
  { text: 'Seguro de Vida Direto — Benefício', value: 'id_swift_2522' },
  { text: 'Seguro de Carga Direto — Prêmio', value: 'id_swift_2523' },
  { text: 'Seguro de Carga Direto — Sinistro', value: 'id_swift_2524' },
  { text: 'Outros Seguros Diretos — Prêmio', value: 'id_swift_2525' },
  { text: 'Outros Seguros Diretos — Sinistro', value: 'id_swift_2526' },
  { text: 'Resseguro — Prêmio', value: 'id_swift_2531' },
  { text: 'Resseguro — Sinistro', value: 'id_swift_2532' },
  { text: 'Resseguro — Comissão', value: 'id_swift_2533' },
  { text: 'Serviços Auxiliares de Seguros', value: 'id_swift_2541' },
  { text: 'Contribuição ao Fundo de Pensão', value: 'id_swift_2546' },
  { text: 'Benefício de Fundo de Pensão', value: 'id_swift_2547' },
  { text: 'Serviços Financeiros', value: 'id_swift_2550' },
  { text: 'Direitos Autorais / Propriedade Intelectual', value: 'id_swift_2560' },
  { text: 'Pesquisa e Desenvolvimento', value: 'id_swift_2570' },
  { text: 'Jurídico, Contabilidade, Consultoria de Gestão e Relações Públicas', value: 'id_swift_2580' },
  { text: 'Publicidade, Pesquisa de Mercado e Pesquisas', value: 'id_swift_2590' },
  { text: 'Arquitetura, Engenharia e Outros Serviços Técnicos', value: 'id_swift_2600' },
  { text: 'Mineração, Agricultura e Gestão de Resíduos / Poluição', value: 'id_swift_2610' },
  { text: 'Leasing Operacional — Aluguel de Bens', value: 'id_swift_2615' },
  { text: 'Leasing Operacional — Aluguel de Transporte sem Tripulação', value: 'id_swift_2616' },
  { text: 'Serviços Relacionados ao Comércio', value: 'id_swift_2630' },
  { text: 'Outros Serviços Empresariais', value: 'id_swift_2640' },
  { text: 'Arte, Cultura e Recreação na Indonésia', value: 'id_swift_2651' },
  { text: 'Arte, Cultura e Recreação no Exterior', value: 'id_swift_2652' },
  { text: 'Serviços Governamentais', value: 'id_swift_2660' },
  { text: 'Outros Serviços', value: 'id_swift_2670' },
  { text: 'Rendimentos de Títulos — Não Residente, até 1 Ano', value: 'id_swift_2701' },
  { text: 'Rendimentos de Títulos — Não Residente, acima de 1 Ano', value: 'id_swift_2702' },
  { text: 'Rendimentos de Conta Corrente, Poupança e Depósitos (incl. Mudharabah)', value: 'id_swift_2705' },
  { text: 'Rendimentos de Conta de Empréstimo (incl. Leasing, Murabahah, Musyarakah)', value: 'id_swift_2710' },
  { text: 'Rendimentos de Títulos — Residente, até 1 Ano', value: 'id_swift_2716' },
  { text: 'Rendimentos de Títulos — Residente, acima de 1 Ano', value: 'id_swift_2717' },
  { text: 'Rendimentos de Gold Swap', value: 'id_swift_2720' },
  { text: 'Dividendos e Lucros', value: 'id_swift_2725' },
  { text: 'Taxa Recebida pelo Proprietário de Títulos — Empréstimo de Títulos', value: 'id_swift_2730' },
  { text: 'Taxa Recebida pelo Proprietário de Títulos — Empréstimo de Ouro ou Gold Swap', value: 'id_swift_2731' },
  { text: 'Aluguel de Terreno', value: 'id_swift_2741' },
  { text: 'Aluguel de Escritório, Apartamento, Moradia e Similares', value: 'id_swift_2742' },
  { text: 'Aluguel de Terreno com Escritório/Apartamento/Moradia e Similares', value: 'id_swift_2743' },
  { text: 'Grant (Dinheiro) — Sem Obrigação de Comprar Ativo Fixo', value: 'id_swift_2751' },
  { text: 'Grant (Dinheiro) — Com Obrigação de Comprar Ativo Fixo', value: 'id_swift_2752' },
  { text: 'Sanção, Multa e Similares', value: 'id_swift_2760' },
  { text: 'Imposto, Contribuição, Restituição e Similares', value: 'id_swift_2765' },
  { text: 'Imposto de Renda e Previdência Social', value: 'id_swift_2766' },
  { text: 'Outros Impostos', value: 'id_swift_2767' },
  { text: 'Direito de Uso de Recursos Naturais', value: 'id_swift_2770' },
  { text: 'Reembolso de Exportação', value: 'id_swift_2802' },
  { text: 'Reembolso de Importação', value: 'id_swift_2803' },
  { text: 'Reembolso — Transação Não Export/Import', value: 'id_swift_2804' },
  { text: 'Capital de Giro / Cash Call — Petróleo e Gás', value: 'id_swift_2808' },
  { text: 'Capital de Giro / Cash Call — Não Petróleo e Gás', value: 'id_swift_2809' },
  { text: 'Pagamento Antecipado — Bens Não Export/Import', value: 'id_swift_2811' },
  { text: 'Pagamento Antecipado — Seguros', value: 'id_swift_2812' },
  { text: 'Outros Pagamentos Antecipados', value: 'id_swift_2813' },
  { text: 'Reembolso de Taxa de Pedido — IPO e Colocação Privada', value: 'id_swift_2814' },
  { text: 'Reembolso de Fundo de Emergência', value: 'id_swift_2815' },
  { text: 'Venda de Títulos Não Residentes com Repo — Proprietário, até 1 Ano', value: 'id_swift_2821' },
  { text: 'Venda de Títulos Não Residentes com Repo — Proprietário, acima de 1 Ano', value: 'id_swift_2822' },
  { text: 'Revenda de Títulos Não Residentes com Repo — Comprador, até 1 Ano', value: 'id_swift_2823' },
  { text: 'Revenda de Títulos Não Residentes com Repo — Comprador, acima de 1 Ano', value: 'id_swift_2824' },
  { text: 'Recompra de Títulos Não Residentes com Repo — Proprietário, até 1 Ano', value: 'id_swift_2825' },
  { text: 'Recompra de Títulos Não Residentes com Repo — Proprietário, acima de 1 Ano', value: 'id_swift_2826' },
  { text: 'Compra de Títulos Não Residentes com Repo — até 1 Ano', value: 'id_swift_2827' },
  { text: 'Compra de Títulos Não Residentes com Repo — acima de 1 Ano', value: 'id_swift_2828' },
  // PH — Filipinas
  { text: 'IED — Transferência de Capital (Ações)', value: 'ph_swift_1010101000' },
  { text: 'IED — Transferência de Capital (Lucros Reinvestidos)', value: 'ph_swift_1010102001' },
  { text: 'IED — Transferência de Capital (Lucros Reinvestidos — Outro Capital)', value: 'ph_swift_1010102002' },
  { text: 'IED — Transferência de Capital (Outro Capital — Empréstimos da Controladora)', value: 'ph_swift_1010103001' },
  { text: 'IED — Transferência de Capital (Outro Capital — Empréstimos de Afiliadas)', value: 'ph_swift_1010103002' },
  { text: 'IEP — Transferência de Capital (Ações)', value: 'ph_swift_1010201000' },
  { text: 'IEP — Transferência de Capital (Títulos de Dívida / Bonds)', value: 'ph_swift_1010202001' },
  { text: 'IEP — Transferência de Capital (Outros Títulos de Dívida)', value: 'ph_swift_1010202002' },
  { text: 'IEP — Transferência de Capital (Instrumentos de Mercado Monetário)', value: 'ph_swift_1010203001' },
  { text: 'IEP — Transferência de Capital (Derivativos Financeiros)', value: 'ph_swift_1010203002' },
  { text: 'Transferência de Capital — Outros Investimentos', value: 'ph_swift_1010300000' },
  { text: 'Transferências Correntes — Remessas de Trabalhadores (Bancos Locais)', value: 'ph_swift_1110100001' },
  { text: 'Transferências Correntes — Privadas (Remessas em Dinheiro — USD)', value: 'ph_swift_1110200001' },
  { text: 'Transferências Correntes — Privadas (Remessas em Dinheiro — EUR)', value: 'ph_swift_1110200002' },
  { text: 'Transferências Correntes — Privadas (Remessas em Dinheiro — JPY)', value: 'ph_swift_1110200003' },
  { text: 'Transferências Correntes — Privadas (Remessas em Dinheiro — Outra Moeda)', value: 'ph_swift_1110200004' },
  { text: 'Transferências Correntes — Privadas (Grants — Organizações Internacionais)', value: 'ph_swift_1110300001' },
  { text: 'Transferências Correntes — Privadas (Grants — Organizações Sem Fins Lucrativos)', value: 'ph_swift_1110300002' },
  { text: 'Transferências Correntes — Privadas (Grants — Pessoas Físicas)', value: 'ph_swift_1110300003' },
  { text: 'Transferências Correntes — Privadas (Grants — Outros Privados)', value: 'ph_swift_1110300004' },
  { text: 'Transferências Correntes — Privadas (Sinistros de Seguro — Vida)', value: 'ph_swift_1110400001' },
  { text: 'Transferências Correntes — Privadas (Sinistros de Seguro — Não Vida)', value: 'ph_swift_1110400002' },
  { text: 'Transferências Correntes — Privadas (Sinistros de Seguro — Resseguro)', value: 'ph_swift_1110400003' },
  { text: 'Transferências Correntes — Privadas (Sinistros de Seguro — Fundos de Pensão)', value: 'ph_swift_1110400004' },
  { text: 'Transferências Correntes — Privadas (Sinistros de Seguro — Garantias Padronizadas)', value: 'ph_swift_1110400005' },
  { text: 'Transferências Correntes — Privadas (Sinistros de Seguro — Outros)', value: 'ph_swift_1110400006' },
  { text: 'Transferências Correntes — Privadas (Benefícios Previdenciários — Trabalhadores Locais)', value: 'ph_swift_1110500001' },
  { text: 'Transferências Correntes — Privadas (Benefícios Previdenciários — OFWs)', value: 'ph_swift_1110500002' },
  { text: 'Transferências Correntes — Privadas (Benefícios Previdenciários — Pensão)', value: 'ph_swift_1110500003' },
  { text: 'Transferências Correntes — Privadas (Benefícios Previdenciários — Anuidade)', value: 'ph_swift_1110500004' },
  { text: 'Transferências Correntes — Privadas (Benefícios Previdenciários — Outros)', value: 'ph_swift_1110500005' },
  { text: 'Transferências Correntes — Privadas (Multas e Penalidades)', value: 'ph_swift_1110600001' },
  { text: 'Transferências Correntes — Privadas (Outras Transferências Correntes)', value: 'ph_swift_1110700001' },
  { text: 'Transferências Correntes — Governo (Grants)', value: 'ph_swift_1310000001' },
  { text: 'Transferências Correntes — Governo (Impostos Correntes sobre Renda e Patrimônio)', value: 'ph_swift_1310000002' },
  { text: 'Transferências Correntes — Governo (Outras Transferências Correntes)', value: 'ph_swift_1310000003' },
  { text: 'Receitas — Remuneração de Empregados (Salários e Ordenados)', value: 'ph_swift_1410100001' },
  { text: 'Receitas — Remuneração de Empregados (Outras Remunerações)', value: 'ph_swift_1410100002' },
  { text: 'Receitas — Renda de Investimento (IED — Dividendos)', value: 'ph_swift_1410200001' },
  { text: 'Receitas — Renda de Investimento (IED — Lucros Reinvestidos)', value: 'ph_swift_1410200002' },
  { text: 'Receitas — Renda de Investimento (IED — Juros Intercompany)', value: 'ph_swift_1410200003' },
  { text: 'Receitas — Renda de Investimento (IED — Lucros de Filial Não Distribuídos)', value: 'ph_swift_1410200004' },
  { text: 'Receitas — Renda de Investimento em Portfólio', value: 'ph_swift_1410300000' },
  { text: 'Receitas — Outras Rendas de Investimento', value: 'ph_swift_1410400000' },
  { text: 'Receitas — Renda de Reservas', value: 'ph_swift_1410500000' },
  { text: 'Receitas — Outras Rendas', value: 'ph_swift_1410600000' },
  { text: 'Exportação de Mercadorias — Mercadoria Geral', value: 'ph_swift_1510000001' },
  { text: 'Exportação de Mercadorias — Processamento', value: 'ph_swift_1510000002' },
  { text: 'Exportação de Mercadorias — Reparo de Bens', value: 'ph_swift_1510000003' },
  { text: 'Exportação de Mercadorias — Suprimentos em Portos', value: 'ph_swift_1510000004' },
  { text: 'Exportação de Mercadorias — Ouro Não Monetário', value: 'ph_swift_1510000005' },
  { text: 'Exportação de Mercadorias — Bens sob Leasing Financeiro (Líquido)', value: 'ph_swift_1510000006' },
  { text: 'Exportação de Mercadorias — Outros Bens', value: 'ph_swift_1510000007' },
  { text: 'Exportação Não Mercadoria — Militar', value: 'ph_swift_1510000008' },
  { text: 'Exportação Não Mercadoria — Embaixadas', value: 'ph_swift_1510000009' },
  { text: 'Exportação Não Mercadoria — Reparo de Bens', value: 'ph_swift_1510000010' },
  { text: 'Exportação Não Mercadoria — Suprimentos por Transportadoras (Marítimo)', value: 'ph_swift_1510000011' },
  { text: 'Exportação Não Mercadoria — Suprimentos por Transportadoras (Aéreo)', value: 'ph_swift_1510000012' },
  { text: 'Exportação Não Mercadoria — Suprimentos por Transportadoras (Terrestre)', value: 'ph_swift_1510000013' },
  { text: 'Exportação Não Mercadoria — Suprimentos por Transportadoras (Outros)', value: 'ph_swift_1510000014' },
  { text: 'Exportação Não Mercadoria — Outras Exportações Não Mercadoria', value: 'ph_swift_1510000015' },
  { text: 'Exportação Direta', value: 'ph_swift_1510000016' },
  { text: 'Exportação Indireta — Processamento', value: 'ph_swift_1510000017' },
  { text: 'Exportação Indireta — Compra e Venda', value: 'ph_swift_1510000018' },
  { text: 'Exportação Indireta — Consignação', value: 'ph_swift_1510000019' },
  { text: 'Exportação Indireta — Joint Venture', value: 'ph_swift_1510000020' },
  { text: 'Exportação Indireta — Outras', value: 'ph_swift_1510000021' },
  { text: 'Exportação — Pagamento Antecipado', value: 'ph_swift_1510000023' },
  { text: 'Exportação — Faturamento Progressivo', value: 'ph_swift_1510000024' },
  { text: 'Exportação — Pagamento Integral', value: 'ph_swift_1510000025' },
  { text: 'Transporte — Frete Marítimo (Manifesto de Saída)', value: 'ph_swift_210000001' },
  { text: 'Transporte — Frete Aéreo (Manifesto de Saída)', value: 'ph_swift_210000002' },
  { text: 'Transporte — Frete Terrestre', value: 'ph_swift_210000003' },
  { text: 'Transporte — Passageiros (Marítimo)', value: 'ph_swift_210000004' },
  { text: 'Transporte — Passageiros (Aéreo)', value: 'ph_swift_210000005' },
  { text: 'Transporte — Passageiros (Terrestre)', value: 'ph_swift_210000006' },
  { text: 'Transporte — Serviços Portuários', value: 'ph_swift_210000007' },
  { text: 'Transporte — Serviços Aeroportuários', value: 'ph_swift_210000008' },
  { text: 'Transporte — Outros Serviços Auxiliares', value: 'ph_swift_210000009' },
  { text: 'Transporte — Outros Serviços de Transporte', value: 'ph_swift_210000010' },
  { text: 'Viagem Corporativa', value: 'ph_swift_510100001' },
  { text: 'Viagem Pessoal', value: 'ph_swift_510200001' },
  { text: 'Viagem Pessoal — Saúde', value: 'ph_swift_510200002' },
  { text: 'Comunicação — Correios / Encomendas', value: 'ph_swift_510301001' },
  { text: 'Comunicação — Telecomunicações', value: 'ph_swift_510301002' },
  { text: 'Comunicação — Internet', value: 'ph_swift_510301003' },
  { text: 'Comunicação — Radiodifusão', value: 'ph_swift_510302001' },
  { text: 'Comunicação — TV a Cabo', value: 'ph_swift_510302002' },
  { text: 'Comunicação — Satélite', value: 'ph_swift_510302003' },
  { text: 'Comunicação — Outras', value: 'ph_swift_510303000' },
  { text: 'Construção Civil no Exterior', value: 'ph_swift_510401000' },
  { text: 'Construção Civil nas Filipinas — Setor Privado', value: 'ph_swift_510402001' },
  { text: 'Construção Civil nas Filipinas — Governo', value: 'ph_swift_510402002' },
  { text: 'Construção Civil nas Filipinas — BOT', value: 'ph_swift_510402003' },
  { text: 'Construção Civil nas Filipinas — Joint Venture', value: 'ph_swift_510402004' },
  { text: 'Construção Civil nas Filipinas — EPIRA', value: 'ph_swift_510402005' },
  { text: 'Construção Civil nas Filipinas — Outras', value: 'ph_swift_510402006' },
  { text: 'Reparos e Manutenção', value: 'ph_swift_510402007' },
  { text: 'Seguros — Seguro de Vida', value: 'ph_swift_510500001' },
  { text: 'Seguros — Não Vida', value: 'ph_swift_510500002' },
  { text: 'Seguros — Resseguro', value: 'ph_swift_510500003' },
  { text: 'Seguros — Fundos de Pensão', value: 'ph_swift_510500004' },
  { text: 'Seguros — Garantias Padronizadas', value: 'ph_swift_510500005' },
  { text: 'Serviços Financeiros — Intermediação Financeira', value: 'ph_swift_510600001' },
  { text: 'Serviços Financeiros — Banco de Investimento', value: 'ph_swift_510600002' },
  { text: 'Serviços Financeiros — Relacionados a Seguros', value: 'ph_swift_510600003' },
  { text: 'Serviços Financeiros — Relacionados a Pensão', value: 'ph_swift_510600004' },
  { text: 'Serviços Financeiros — Outros', value: 'ph_swift_510600005' },
  { text: 'Computação e Informação — Software', value: 'ph_swift_510700000' },
  { text: 'Royalties — Franquias', value: 'ph_swift_510800001' },
  { text: 'Royalties — Outros', value: 'ph_swift_510800002' },
  { text: 'Outros Serviços Empresariais — Comercialização', value: 'ph_swift_510900000' },
  { text: 'Outros Serviços Empresariais — Leasing Operacional', value: 'ph_swift_511000001' },
  { text: 'Outros Serviços Empresariais — Leasing Financeiro', value: 'ph_swift_511000002' },
  { text: 'Outros Serviços Empresariais — Jurídico', value: 'ph_swift_511100001' },
  { text: 'Outros Serviços Empresariais — Contabilidade', value: 'ph_swift_511100002' },
  { text: 'Outros Serviços Empresariais — Consultoria de Gestão', value: 'ph_swift_511100003' },
  { text: 'Outros Serviços Empresariais — Publicidade', value: 'ph_swift_511200000' },
  { text: 'Outros Serviços Empresariais — Pesquisa e Desenvolvimento', value: 'ph_swift_511300001' },
  { text: 'Outros Serviços Empresariais — Arquitetura', value: 'ph_swift_511300002' },
  { text: 'Outros Serviços Empresariais — Engenharia', value: 'ph_swift_511300003' },
  { text: 'Outros Serviços Empresariais — Agropecuária', value: 'ph_swift_511300004' },
  { text: 'Outros Serviços Empresariais — Mineração', value: 'ph_swift_511300005' },
  { text: 'Outros Serviços Empresariais — Meio Ambiente', value: 'ph_swift_511300006' },
  { text: 'Outros Serviços Empresariais — Outros Serviços Técnicos', value: 'ph_swift_511300007' },
  { text: 'Outros Serviços Empresariais — Comércio', value: 'ph_swift_511300008' },
  { text: 'Serviços Governamentais — Embaixadas e Consulados', value: 'ph_swift_511400001' },
  { text: 'Serviços Governamentais — Organizações Internacionais', value: 'ph_swift_511400002' },
  { text: 'Serviços Governamentais — Operações Militares', value: 'ph_swift_511400003' },
  { text: 'Serviços Governamentais — Missões Diplomáticas', value: 'ph_swift_511400004' },
  { text: 'Serviços Governamentais — Outros', value: 'ph_swift_511400005' },
  { text: 'Serviços Pessoais — Educação', value: 'ph_swift_511500001' },
  { text: 'Serviços Pessoais — Saúde', value: 'ph_swift_511500002' },
  { text: 'Serviços Pessoais — Recreação / Cultura / Esportes', value: 'ph_swift_511500003' },
  { text: 'Serviços Pessoais — Outros', value: 'ph_swift_511500004' },
  { text: 'Outros Serviços — IT-BPO', value: 'ph_swift_511600001' },
  { text: 'Outros Serviços — Turismo', value: 'ph_swift_511600002' },
  { text: 'Outros Serviços — Não Classificados', value: 'ph_swift_511600003' },
  { text: 'Outros Serviços — Turismo Médico', value: 'ph_swift_511700001' },
  { text: 'Outros Serviços — Aposentadoria', value: 'ph_swift_511700002' },
  { text: 'Outros Serviços — Outros Tipos de Turismo', value: 'ph_swift_511700003' },
  { text: 'Empréstimos — Curto Prazo (Desembolso)', value: 'ph_swift_610000001' },
  { text: 'Empréstimos — Curto Prazo (Amortização)', value: 'ph_swift_610000002' },
  { text: 'Empréstimos — Longo Prazo (Desembolso)', value: 'ph_swift_610000003' },
  { text: 'Empréstimos — Longo Prazo (Amortização)', value: 'ph_swift_610000004' },
  { text: 'Empréstimos — Longo Prazo (Outros)', value: 'ph_swift_610000005' },
  { text: 'Crédito Comercial — Curto Prazo', value: 'ph_swift_610000006' },
  { text: 'Crédito Comercial — Longo Prazo', value: 'ph_swift_610000007' },
  { text: 'Depósitos em Moeda Estrangeira — Entrada (Novo Depósito)', value: 'ph_swift_710100001' },
  { text: 'Depósitos em Moeda Estrangeira — Entrada (Juros FCDU/EFCDU)', value: 'ph_swift_710100002' },
  { text: 'Depósitos em Moeda Estrangeira — Entrada (Outros)', value: 'ph_swift_710100003' },
  { text: 'Depósitos em Moeda Estrangeira — Saída (Saque)', value: 'ph_swift_710100004' },
  { text: 'Depósitos em Moeda Estrangeira — Saída (Transferência para Outros Bancos)', value: 'ph_swift_710100006' },
  { text: 'Depósitos em Moeda Estrangeira — Saída (Financiamento de Pagamentos no Exterior)', value: 'ph_swift_710100007' },
  { text: 'Depósitos em Moeda Estrangeira — Saída (Outros)', value: 'ph_swift_710100008' },
  { text: 'Depósitos em Moeda Estrangeira — Saída (Transferência ao BSP)', value: 'ph_swift_710100009' },
  { text: 'Depósitos Interbancários — Entrada (Aplicações de Bancos Estrangeiros)', value: 'ph_swift_710200001' },
  { text: 'Depósitos Interbancários — Entrada (Transferências de Bancos Estrangeiros)', value: 'ph_swift_710200002' },
  { text: 'Depósitos Interbancários — Entrada (Outros)', value: 'ph_swift_710200003' },
  { text: 'Depósitos Interbancários — Saída (Saques de Bancos Estrangeiros)', value: 'ph_swift_710200004' },
  { text: 'Depósitos Interbancários — Saída (Outros)', value: 'ph_swift_710200009' },
  { text: 'Contas Nostro — Entrada', value: 'ph_swift_710300001' },
  { text: 'Contas Nostro — Entrada (Juros)', value: 'ph_swift_710300002' },
  { text: 'Contas Nostro — Entrada (Outros)', value: 'ph_swift_710300003' },
  { text: 'Contas Nostro — Saída', value: 'ph_swift_710300004' },
  { text: 'Contas Nostro — Saída (Outros)', value: 'ph_swift_710300009' },
  { text: 'Outros Depósitos — Entrada', value: 'ph_swift_710400001' },
  { text: 'Outros Depósitos — Saída', value: 'ph_swift_710400002' },
  { text: 'Liquidação de Exportação — Carta de Crédito à Vista', value: 'ph_swift_810101001' },
  { text: 'Liquidação de Exportação — Carta de Crédito a Prazo (Usance)', value: 'ph_swift_810101002' },
  { text: 'Liquidação de Exportação — Carta de Crédito com Pagamento Diferido', value: 'ph_swift_810101003' },
  { text: 'Liquidação de Exportação — Carta de Crédito com Negociação com Recurso', value: 'ph_swift_810101004' },
  { text: 'Liquidação de Exportação — Outros Tipos de LC', value: 'ph_swift_810101007' },
  { text: 'Liquidação de Exportação — Carta de Crédito em Moeda Estrangeira', value: 'ph_swift_810101008' },
  { text: 'Liquidação de Exportação — Outras Liquidações de LC', value: 'ph_swift_810101011' },
  { text: 'Liquidação de Exportação — Cobrança Documentária (Documentos contra Pagamento)', value: 'ph_swift_810102001' },
  { text: 'Liquidação de Exportação — Cobrança Documentária (Documentos contra Aceite)', value: 'ph_swift_810102002' },
  { text: 'Liquidação de Exportação — Cobrança Simples (Clean Collection)', value: 'ph_swift_810102003' },
  { text: 'Liquidação de Exportação — Cobrança Documentária (Outros Tipos de Documentos)', value: 'ph_swift_810102004' },
  { text: 'Liquidação de Exportação — Pagamento Parcial Antecipado', value: 'ph_swift_810102005' },
  { text: 'Liquidação de Exportação — Pagamento Diferido', value: 'ph_swift_810102006' },
  { text: 'Liquidação de Exportação — Cobrança em Moeda Estrangeira', value: 'ph_swift_810102007' },
  { text: 'Liquidação de Exportação — Outros Tipos de Cobrança', value: 'ph_swift_810102008' },
  { text: 'Liquidação de Exportação — Conta Aberta (Open Account)', value: 'ph_swift_810102009' },
  { text: 'Liquidação de Importação — Carta de Crédito à Vista', value: 'ph_swift_810201001' },
  { text: 'Liquidação de Importação — Carta de Crédito a Prazo (Usance)', value: 'ph_swift_810201002' },
  { text: 'Liquidação de Importação — Carta de Crédito com Pagamento Diferido', value: 'ph_swift_810201003' },
  { text: 'Liquidação de Importação — Outros Tipos de LC', value: 'ph_swift_810201004' },
  { text: 'Liquidação de Importação — Cobrança Documentária (Documentos contra Pagamento)', value: 'ph_swift_810202001' },
  { text: 'Liquidação de Importação — Cobrança Documentária (Documentos contra Aceite)', value: 'ph_swift_810202002' },
  { text: 'Liquidação de Importação — Cobrança Simples (Clean Collection)', value: 'ph_swift_810202003' },
  { text: 'Liquidação de Importação — Cobrança Documentária (Outros Tipos de Documentos)', value: 'ph_swift_810202005' },
  { text: 'Liquidação de Importação — Outros Tipos de Cobrança', value: 'ph_swift_810202006' },
  { text: 'Operações Próprias do Banco — Entrada (Capital)', value: 'ph_swift_910100001' },
  { text: 'Operações Próprias do Banco — Entrada (Desembolso de Empréstimos)', value: 'ph_swift_910100002' },
  { text: 'Operações Próprias do Banco — Entrada (Pagamento de Empréstimos)', value: 'ph_swift_910100003' },
  { text: 'Operações Próprias do Banco — Entrada (Depósitos de Bancos Estrangeiros)', value: 'ph_swift_910100004' },
  { text: 'Operações Próprias do Banco — Entrada (Compras de Câmbio)', value: 'ph_swift_910100005' },
  { text: 'Operações Próprias do Banco — Entrada (Renda de Investimento)', value: 'ph_swift_910100006' },
  { text: 'Operações Próprias do Banco — Entrada (Outros)', value: 'ph_swift_910100007' },
  { text: 'Operações Próprias do Banco — Entrada (Transferências do BSP)', value: 'ph_swift_910100009' },
  { text: 'Operações Próprias do Banco — Entrada (Transferências de Bancos Estrangeiros)', value: 'ph_swift_910100010' },
  { text: 'Operações Próprias do Banco — Entrada (Outras Transferências)', value: 'ph_swift_910100011' },
  { text: 'Operações Próprias do Banco — Saída (Capital)', value: 'ph_swift_910200001' },
  { text: 'Operações Próprias do Banco — Saída (Desembolso de Empréstimos)', value: 'ph_swift_910200002' },
  { text: 'Operações Próprias do Banco — Saída (Pagamento de Empréstimos)', value: 'ph_swift_910200003' },
  { text: 'Operações Próprias do Banco — Saída (Depósitos em Bancos Estrangeiros)', value: 'ph_swift_910200004' },
  { text: 'Operações Próprias do Banco — Saída (Vendas de Câmbio)', value: 'ph_swift_910200005' },
  { text: 'Operações Próprias do Banco — Saída (Renda de Investimento)', value: 'ph_swift_910200006' },
  { text: 'Operações Próprias do Banco — Saída (Outros)', value: 'ph_swift_910200007' },
  { text: 'Operações Próprias do Banco — Saída (Transferências ao BSP)', value: 'ph_swift_910200009' },
  { text: 'Operações Próprias do Banco — Saída (Transferências a Bancos Estrangeiros)', value: 'ph_swift_910200010' },
  { text: 'Operações Próprias do Banco — Saída (Outras Transferências)', value: 'ph_swift_910200011' },
  // PK — Paquistão
  { text: 'Exportação de Mercadorias', value: 'pk_swift_9009' },
  { text: 'Comissão de Exportação', value: 'pk_swift_9010' },
  { text: 'Exportação em Consignação', value: 'pk_swift_9011' },
  { text: 'Exportação a Crédito / Pagamento Diferido', value: 'pk_swift_9012' },
  { text: 'Exportação com Seguro de Crédito Oficial', value: 'pk_swift_9013' },
  { text: 'Recebimento de Adiantamento Previamente Pago para Exportação', value: 'pk_swift_9014' },
  { text: 'Serviços de Subcontratado no Exterior', value: 'pk_swift_9015' },
  { text: 'Serviços de Construção no Exterior', value: 'pk_swift_9016' },
  { text: 'Manutenção e Reparo de Bens de Capital', value: 'pk_swift_9017' },
  { text: 'Operação de Equipamento de Transporte — Frete, Afretamento', value: 'pk_swift_9018' },
  { text: 'Salários de Trabalhadores Paquistaneses no Exterior', value: 'pk_swift_9019' },
  { text: 'Serviços de Imóveis — Locação', value: 'pk_swift_9020' },
  { text: 'Subcontratação de Serviços (Exceto Construção)', value: 'pk_swift_9021' },
  { text: 'Serviços Jurídicos, Contábeis, Publicidade e Outros Empresariais', value: 'pk_swift_9022' },
  { text: 'Outros Serviços Não Classificados', value: 'pk_swift_9023' },
  { text: 'Serviços de TI — Consultoria, Software, Dados', value: 'pk_swift_9024' },
  { text: 'Royalties / Propriedade Intelectual', value: 'pk_swift_9025' },
  { text: 'Dividendos / Lucros — Investimento Direto no Exterior', value: 'pk_swift_9026' },
  { text: 'Dividendos — Investimento em Portfólio no Exterior', value: 'pk_swift_9027' },
  { text: 'Juros sobre Empréstimos a Empresas Estrangeiras', value: 'pk_swift_9028' },
  { text: 'Juros sobre Títulos / Debêntures de Não Residentes', value: 'pk_swift_9029' },
  { text: 'Juros sobre Depósitos em Moeda Estrangeira', value: 'pk_swift_9030' },
  { text: 'Comissão de Agentes no Paquistão', value: 'pk_swift_9031' },
  { text: 'Serviços de Navegação Marítima — Frete e Sobrestadia', value: 'pk_swift_9032' },
  { text: 'Serviços Aéreos — Frete e Sobrestadia', value: 'pk_swift_9033' },
  { text: 'Rendimentos de Investimentos no Exterior (Fundos Mútuos, Unit Trusts)', value: 'pk_swift_9041' },
  { text: 'Passagem Marítima de Não Residentes', value: 'pk_swift_9051' },
  { text: 'Passagem Aérea de Não Residentes', value: 'pk_swift_9052' },
  { text: 'Tratamento Médico de Não Residentes no Paquistão', value: 'pk_swift_9061' },
  { text: 'Educação de Não Residentes no Paquistão', value: 'pk_swift_9071' },
  { text: 'Treinamento de Estrangeiros no Paquistão', value: 'pk_swift_9072' },
  { text: 'Educação / Treinamento Online por Instituições Paquistanesas', value: 'pk_swift_9073' },
  { text: 'Câmbio por Nacionais Paquistaneses de Visita ao País', value: 'pk_swift_9081' },
  { text: 'Câmbio por Turistas Estrangeiros no Paquistão', value: 'pk_swift_9082' },
  { text: 'Recebimentos de Visitantes Religiosos no Paquistão', value: 'pk_swift_9083' },
  { text: 'Devolução de Câmbio Não Utilizado — Viagem ao Exterior', value: 'pk_swift_9084' },
  { text: 'Devolução de Câmbio Não Utilizado — Hajjis', value: 'pk_swift_9085' },
  { text: 'Devolução de Câmbio Não Utilizado — Umrah / Ziarat', value: 'pk_swift_9086' },
  { text: 'Serviços Postais de Não Residentes', value: 'pk_swift_9091' },
  { text: 'Serviços de Courier de Não Residentes', value: 'pk_swift_9092' },
  { text: 'Serviços de Telecomunicação', value: 'pk_swift_9101' },
  { text: 'Call Centers — Serviços Prestados', value: 'pk_swift_9102' },
  { text: 'Remessa de Construção no Exterior', value: 'pk_swift_9111' },
  { text: 'Seguros de Vida e Fundos de Pensão — Prêmios', value: 'pk_swift_9121' },
  { text: 'Remessas de Seguradoras de Vida Paquistanesas no Exterior', value: 'pk_swift_9122' },
  { text: 'Reembolso de Seguros e Pensões', value: 'pk_swift_9124' },
  { text: 'Seguros Não Vida — Prêmios', value: 'pk_swift_9141' },
  { text: 'Reembolso de Outros Seguros Diretos', value: 'pk_swift_9146' },
  { text: 'Resseguro de Vida — Prêmios', value: 'pk_swift_9151' },
  { text: 'Resseguro Não Vida — Prêmios', value: 'pk_swift_9152' },
  { text: 'Serviços Auxiliares de Seguros — Corretagem e Agência', value: 'pk_swift_9161' },
  { text: 'Serviços Financeiros — Taxas de Intermediação Bancária', value: 'pk_swift_9171' },
  { text: 'Execução de Garantias Bancárias', value: 'pk_swift_9172' },
  { text: 'Outros Serviços Financeiros — Banco de Investimento, M&A, Corretagem', value: 'pk_swift_9173' },
  { text: 'Reembolso de Serviços Financeiros', value: 'pk_swift_9174' },
  { text: 'Consultoria de Hardware de TI para Não Residentes', value: 'pk_swift_9181' },
  { text: 'Serviços de Banco de Dados para Não Residentes', value: 'pk_swift_9182' },
  { text: 'Manutenção de Computadores no Exterior para Não Residentes', value: 'pk_swift_9183' },
  { text: 'Exportação de Software Personalizado', value: 'pk_swift_9184' },
  { text: 'Exportação de Software Empacotado', value: 'pk_swift_9185' },
  { text: 'Outros Serviços de TI para Não Residentes', value: 'pk_swift_9186' },
  { text: 'Serviços de Agência de Notícias para Não Residentes', value: 'pk_swift_9191' },
  { text: 'Serviços de Biblioteca e Arquivo para Não Residentes', value: 'pk_swift_9192' },
  { text: 'Outros Serviços de Informação para Não Residentes', value: 'pk_swift_9193' },
  { text: 'Royalties — Propriedade Intelectual (Patentes, Marcas, Franquias)', value: 'pk_swift_9201' },
  { text: 'Royalties — Direitos Autorais Audiovisuais', value: 'pk_swift_9202' },
  { text: 'Serviços de Facilitação Comercial (Finanças, Documentação, Alfândega)', value: 'pk_swift_9211' },
  { text: 'Leasing Operacional', value: 'pk_swift_9212' },
  { text: 'Serviços Jurídicos', value: 'pk_swift_9221' },
  { text: 'Serviços de Contabilidade e Auditoria', value: 'pk_swift_9222' },
  { text: 'Gestão Empresarial e Relações Públicas', value: 'pk_swift_9230' },
  { text: 'Serviços de Publicidade', value: 'pk_swift_9231' },
  { text: 'Pesquisa de Mercado e Pesquisa de Opinião', value: 'pk_swift_9232' },
  { text: 'Pesquisa e Desenvolvimento', value: 'pk_swift_9233' },
  { text: 'Serviços de Arquitetura', value: 'pk_swift_9234' },
  { text: 'Serviços de Engenharia', value: 'pk_swift_9235' },
  { text: 'Mineração e Prospecção', value: 'pk_swift_9236' },
  { text: 'Serviços Agropecuários', value: 'pk_swift_9237' },
  { text: 'Serviços Ambientais', value: 'pk_swift_9238' },
  { text: 'Outros Serviços Empresariais Diversos', value: 'pk_swift_9239' },
  { text: 'Serviços Audiovisuais — Filmes', value: 'pk_swift_9241' },
  { text: 'Serviços Audiovisuais — Rádio e TV', value: 'pk_swift_9242' },
  { text: 'Serviços Audiovisuais — VHS, CD, DVD', value: 'pk_swift_9243' },
  { text: 'Serviços Audiovisuais — Multimídia', value: 'pk_swift_9244' },
  { text: 'Outros Serviços Audiovisuais', value: 'pk_swift_9247' },
  { text: 'Serviços Pessoais', value: 'pk_swift_9248' },
  { text: 'Serviços Culturais', value: 'pk_swift_9249' },
  { text: 'Serviços Recreativos', value: 'pk_swift_9250' },
  { text: 'Serviços Educacionais', value: 'pk_swift_9251' },
  { text: 'Serviços a Governos Não Classificados', value: 'pk_swift_9261' },
  { text: 'Serviços de Saúde Não Classificados', value: 'pk_swift_9262' },
  { text: 'Serviços de Esportes e Recreação', value: 'pk_swift_9271' },
  { text: 'Serviços a Embaixadas e Consulados', value: 'pk_swift_9272' },
  { text: 'Serviços a Organizações Internacionais', value: 'pk_swift_9273' },
  { text: 'Serviços Diplomáticos, Consulares e Governamentais', value: 'pk_swift_9281' },
  { text: 'Outros Serviços Não Classificados', value: 'pk_swift_9291' },
  { text: 'Remessas de Trabalhadores Estrangeiros Residentes no Paquistão', value: 'pk_swift_9301' },
  { text: 'Transferências de Imigrantes para o Paquistão', value: 'pk_swift_9302' },
  { text: 'Outras Transferências Correntes', value: 'pk_swift_9303' },
  { text: 'Assistência Oficial ao Desenvolvimento (AOD) — Grants', value: 'pk_swift_9311' },
  { text: 'Assistência Oficial ao Desenvolvimento (AOD) — Empréstimos', value: 'pk_swift_9312' },
  { text: 'Investimento Direto Estrangeiro — Ações no Paquistão', value: 'pk_swift_9322' },
  { text: 'Empréstimos Intercompany da Controladora', value: 'pk_swift_9323' },
  { text: 'Lucros Reinvestidos', value: 'pk_swift_9324' },
  { text: 'Investimento em Portfólio — Títulos de Dívida do Paquistão', value: 'pk_swift_9331' },
  { text: 'Investimento em Portfólio — Ações do Paquistão', value: 'pk_swift_9332' },
  { text: 'Outros Investimentos em Portfólio', value: 'pk_swift_9333' },
  { text: 'Empréstimos de Instituições Financeiras Não Bancárias do Exterior', value: 'pk_swift_9341' },
  { text: 'Crédito Comercial — Importadores de Fornecedores Estrangeiros', value: 'pk_swift_9351' },
  { text: 'Adiantamentos de Compradores Estrangeiros para Exportações Futuras', value: 'pk_swift_9361' },
  { text: 'Aplicações de Curto Prazo do Exterior em Bancos no Paquistão', value: 'pk_swift_9381' },
  { text: 'Moeda Estrangeira em Circulação (Notas e Moedas)', value: 'pk_swift_9391' },
  { text: 'Saques do SBP de Contas no Exterior', value: 'pk_swift_9401' },
  { text: 'Compras e Empréstimos do FMI', value: 'pk_swift_9412' },
  { text: 'Alocação de Direitos Especiais de Saque (DES) pelo FMI', value: 'pk_swift_9414' },
  { text: 'Venda de Ouro Monetário pelo SBP', value: 'pk_swift_9421' },
  { text: 'Empréstimos de Curto Prazo Tomados por Bancos do Exterior', value: 'pk_swift_9422' },
  { text: 'Aplicações de Bancos no Exterior — até 3 Meses', value: 'pk_swift_9423' },
  { text: 'Aplicações de Bancos no Exterior — 3 Meses a 1 Ano', value: 'pk_swift_9426' },
  { text: 'Empréstimos de Curto Prazo entre Bancos no Paquistão', value: 'pk_swift_9431' },
  { text: 'Aplicações Interbancárias de Curto Prazo no Paquistão', value: 'pk_swift_9432' },
  { text: 'Aplicações Interbancárias de Curto Prazo do Exterior', value: 'pk_swift_9433' },
  { text: 'Aplicações Interbancárias de Curto Prazo no Paquistão — Bancos Islâmicos', value: 'pk_swift_9434' },
  { text: 'Aplicações Interbancárias de Curto Prazo do Exterior — Bancos Islâmicos', value: 'pk_swift_9435' },
  { text: 'Empréstimos Comerciais de Curto Prazo do Exterior por Bancos', value: 'pk_swift_9441' },
  { text: 'Empréstimos Comerciais de Curto Prazo no Paquistão por Bancos', value: 'pk_swift_9442' },
  { text: 'Empréstimos Comerciais de Curto Prazo do Exterior por Bancos Islâmicos', value: 'pk_swift_9443' },
  { text: 'Empréstimos Comerciais de Curto Prazo no Paquistão por Bancos Islâmicos', value: 'pk_swift_9444' },
  { text: 'Empréstimos Comerciais de Curto Prazo do Exterior por NBFI', value: 'pk_swift_9445' },
  { text: 'Outros Empréstimos de Curto Prazo do Exterior', value: 'pk_swift_9448' },
  { text: 'Depósitos em FCBU do SBP / Refinanciamento de Exportações', value: 'pk_swift_9451' },
  { text: 'Depósitos em PKR no SBP por Bancos', value: 'pk_swift_9452' },
  { text: 'Depósitos NIDA por Bancos', value: 'pk_swift_9453' },
  { text: 'Depósitos NIDA por Bancos Islâmicos', value: 'pk_swift_9454' },
  { text: 'Depósitos de Filiais de Bancos Estrangeiros no Paquistão', value: 'pk_swift_9455' },
  { text: 'Depósitos Recebidos de Pessoas Físicas Estrangeiras', value: 'pk_swift_9456' },
  { text: 'Depósitos NRE (Non-Resident External)', value: 'pk_swift_9457' },
  { text: 'Depósitos NRO (Non-Resident Ordinary)', value: 'pk_swift_9458' },
  { text: 'Depósitos NREA (Non-Resident External Account)', value: 'pk_swift_9459' },
  { text: 'Empréstimos de Longo Prazo Tomados por Bancos do Exterior', value: 'pk_swift_9461' },
  { text: 'Aplicações de Bancos no Exterior — 1 Ano ou Mais', value: 'pk_swift_9462' },
  { text: 'Empréstimos de Longo Prazo entre Bancos no Paquistão', value: 'pk_swift_9463' },
  { text: 'Empréstimos Comerciais de Longo Prazo do Exterior por Bancos', value: 'pk_swift_9468' },
  { text: 'Empréstimos Comerciais de Longo Prazo no Paquistão por Bancos', value: 'pk_swift_9469' },
  { text: 'Empréstimos Comerciais de Longo Prazo do Exterior por Bancos Islâmicos', value: 'pk_swift_9470' },
  { text: 'Empréstimos Comerciais de Longo Prazo no Paquistão por Bancos Islâmicos', value: 'pk_swift_9471' },
  { text: 'Empréstimos Comerciais de Longo Prazo do Exterior por NBFI', value: 'pk_swift_9472' },
  { text: 'Outros Empréstimos de Longo Prazo do Exterior', value: 'pk_swift_9473' },
  { text: 'Depósitos Interbancários em Moeda Estrangeira (IBFCD)', value: 'pk_swift_9474' },
  { text: 'Aplicações Interbancárias de Longo Prazo no Paquistão', value: 'pk_swift_9475' },
  { text: 'Aplicações Interbancárias de Longo Prazo do Exterior', value: 'pk_swift_9476' },
  { text: 'Aplicações Interbancárias de Longo Prazo no Paquistão — Bancos Islâmicos', value: 'pk_swift_9477' },
  { text: 'Aplicações Interbancárias de Longo Prazo do Exterior — Bancos Islâmicos', value: 'pk_swift_9478' },
  { text: 'Empréstimos Subordinados de Bancos no Exterior', value: 'pk_swift_9479' },
  { text: 'Transferências da Comissão Nacional de Finanças (NFC Award)', value: 'pk_swift_9481' },
  { text: 'Grants de Apoio Orçamentário', value: 'pk_swift_9482' },
  { text: 'Transferências Relacionadas a Impostos', value: 'pk_swift_9483' },
  { text: 'Grants Governamentais Não Classificados', value: 'pk_swift_9484' },
  { text: 'Pakistan Investment Bonds (PIBs)', value: 'pk_swift_9491' },
  { text: 'Letras do Tesouro (T-Bills)', value: 'pk_swift_9492' },
  { text: 'Market Treasury Bills (MTBs)', value: 'pk_swift_9493' },
  { text: 'Eurobonds Emitidos pelo Paquistão', value: 'pk_swift_9494' },
  { text: 'Investimento Direto Paquistanês no Exterior — Ações', value: 'pk_swift_9501' },
  { text: 'Empréstimos Intercompany para Afiliadas no Exterior', value: 'pk_swift_9502' },
  { text: 'Desinvestimento no Exterior', value: 'pk_swift_9503' },
  { text: 'NFCBA — Crédito Não Baseado em Fundos a Bancos no Exterior', value: 'pk_swift_9521' },
  { text: 'Compra de Ações / Títulos de Empresas Estrangeiras', value: 'pk_swift_9522' },
  { text: 'Compra de Letras do Tesouro de Governos Estrangeiros', value: 'pk_swift_9523' },
  { text: 'Compra de Títulos do Tesouro de Governos Estrangeiros', value: 'pk_swift_9524' },
  { text: 'Compra de Certificados de Depósito (CDs) de Bancos Estrangeiros', value: 'pk_swift_9525' },
  { text: 'Compra de Fundos Mútuos / Unit Trusts por Residentes', value: 'pk_swift_9526' },
  { text: 'Compra de Outros Instrumentos de Portfólio de Não Residentes', value: 'pk_swift_9527' },
  { text: 'Aplicações de Curto Prazo em Bancos Estrangeiros (até 1 Ano)', value: 'pk_swift_9528' },
  { text: 'Aplicações de Curto Prazo em Bancos Estrangeiros (1 a 3 Meses)', value: 'pk_swift_9529' },
  { text: 'Aplicações de Curto Prazo em Bancos Estrangeiros (3 Meses a 1 Ano)', value: 'pk_swift_9530' },
  { text: 'Aplicações de Longo Prazo em Bancos Estrangeiros (acima de 1 Ano)', value: 'pk_swift_9531' },
  { text: 'Aplicações em Bancos Estrangeiros sob Repo — Curto Prazo', value: 'pk_swift_9532' },
  { text: 'Aplicações em Bancos Estrangeiros sob Repo — Longo Prazo', value: 'pk_swift_9533' },
  { text: 'Recebimentos de Aplicações em Empresas de Câmbio no Exterior', value: 'pk_swift_9534' },
  { text: 'Entradas para Facilidade de Refinanciamento de Exportações (ERF) no SBP', value: 'pk_swift_9535' },
  { text: 'Bancos Islâmicos — Depósitos Murabaha do Exterior', value: 'pk_swift_9536' },
  { text: 'Bancos Islâmicos — Depósitos Musharaka do Exterior', value: 'pk_swift_9537' },
  { text: 'Bancos Islâmicos — Depósitos Ijarah do Exterior', value: 'pk_swift_9538' },
  { text: 'Bancos Islâmicos — Outros Depósitos Islâmicos do Exterior', value: 'pk_swift_9539' },
  { text: 'Venda de Ações em Empresas Listadas', value: 'pk_swift_9541' },
  { text: 'Venda de Cotas de Fundos Mútuos / Unit Trusts', value: 'pk_swift_9542' },
  { text: 'Venda de Instrumentos de Poupança Nacional', value: 'pk_swift_9543' },
  { text: 'Venda de Outros Títulos Domésticos a Não Residentes', value: 'pk_swift_9544' },
  { text: 'Venda de Instrumentos Islâmicos a Não Residentes — Sukuk', value: 'pk_swift_9545' },
  { text: 'Venda de Instrumentos Islâmicos a Não Residentes — Outros', value: 'pk_swift_9546' },
  { text: 'Venda de Ações em Empresas de Capital Estrangeiro', value: 'pk_swift_9547' },
  { text: 'Venda de Cotas de Fundos Estrangeiros', value: 'pk_swift_9548' },
  { text: 'Venda de Outros Títulos Estrangeiros', value: 'pk_swift_9549' },
  { text: 'Remessas de Trabalhadores — Canais Bancários Oficiais', value: 'pk_swift_9551' },
  { text: 'Remessas de Trabalhadores — Iniciativa HRI', value: 'pk_swift_9552' },
  { text: 'Remessas de Trabalhadores — Empresas de Câmbio', value: 'pk_swift_9553' },
  { text: 'Remessas de Trabalhadores — Agências Internacionais', value: 'pk_swift_9554' },
  { text: 'Manutenção Familiar do Exterior', value: 'pk_swift_9555' },
  { text: 'Presentes Pessoais ou Herança do Exterior', value: 'pk_swift_9556' },
  { text: 'Remessas de Doação de Pessoas Físicas no Exterior', value: 'pk_swift_9561' },
  { text: 'Dotações do Exterior', value: 'pk_swift_9562' },
  { text: 'Herança do Exterior', value: 'pk_swift_9563' },
  { text: 'Impostos e Taxas do Exterior', value: 'pk_swift_9564' },
  { text: 'Contribuições Previdenciárias do Exterior', value: 'pk_swift_9565' },
  { text: 'Multas e Penalidades do Exterior', value: 'pk_swift_9566' },
  { text: 'Doações Filantrópicas do Exterior', value: 'pk_swift_9572' },
  { text: 'Auxílio Humanitário do Exterior', value: 'pk_swift_9573' },
  { text: 'Outras Transferências Correntes do Exterior', value: 'pk_swift_9574' },
  { text: 'Transferências de Capital de Pessoas Físicas no Exterior', value: 'pk_swift_9582' },
  { text: 'Transferências de Capital de Empresas no Exterior', value: 'pk_swift_9583' },
  { text: 'Transferências de Capital de Governos no Exterior', value: 'pk_swift_9584' },
  { text: 'Cancelamento de Dívida', value: 'pk_swift_9592' },
  { text: 'Aquisição / Alienação de Ativos Não Produzidos Não Financeiros', value: 'pk_swift_9593' },
  { text: 'Grants de Investimento do Exterior', value: 'pk_swift_9594' },
  { text: 'Assunção de Dívida do Exterior', value: 'pk_swift_9595' },
  { text: 'Outras Transferências de Capital do Exterior', value: 'pk_swift_9596' },
  { text: 'Outros Recebimentos de Capital Não Classificados', value: 'pk_swift_9597' },
  { text: 'Reembolso de Empréstimos Comerciais de Curto Prazo a Não Residentes', value: 'pk_swift_9602' },
  { text: 'Reembolso de Principal de Leasing Financeiro de Curto Prazo a Não Residentes', value: 'pk_swift_9605' },
  { text: 'Reembolso de Empréstimos Sindicalizados de Curto Prazo a Não Residentes', value: 'pk_swift_9606' },
  { text: 'Reembolso de Outros Empréstimos de Curto Prazo a Não Residentes', value: 'pk_swift_9607' },
  { text: 'Reembolso de Empréstimos de Curto Prazo pelo SBP a Não Residentes', value: 'pk_swift_9608' },
  { text: 'Outras Transações Financeiras de Curto Prazo', value: 'pk_swift_9609' },
  { text: 'Reembolso de Empréstimos Comerciais de Longo Prazo a Não Residentes', value: 'pk_swift_9612' },
  { text: 'Reembolso de Principal de Leasing Financeiro de Longo Prazo a Não Residentes', value: 'pk_swift_9613' },
  { text: 'Reembolso de Empréstimos Sindicalizados de Longo Prazo a Não Residentes', value: 'pk_swift_9614' },
  { text: 'Reembolso de Outros Empréstimos de Longo Prazo a Não Residentes', value: 'pk_swift_9622' },
  { text: 'Reembolso de Empréstimos de Longo Prazo pelo SBP a Não Residentes', value: 'pk_swift_9623' },
  { text: 'Juros sobre Empréstimos de Longo Prazo a Não Residentes', value: 'pk_swift_9624' },
  { text: 'Outras Transações Financeiras de Longo Prazo', value: 'pk_swift_9625' },
  { text: 'Captações de Curto Prazo por Bancos de Outros Bancos no Paquistão', value: 'pk_swift_9637' },
  { text: 'Captações de Curto Prazo por Bancos do Exterior', value: 'pk_swift_9638' },
  { text: 'Captações de Longo Prazo por Bancos de Outros Bancos no Paquistão', value: 'pk_swift_9641' },
  { text: 'Captações por Bancos contra Saldos de Contas em Moeda Estrangeira', value: 'pk_swift_9642' },
  { text: 'Swap de Moeda Estrangeira por Bancos no Paquistão — 1 Ano ou Mais (Interbank)', value: 'pk_swift_9643' },
  { text: 'Swap de Moeda Estrangeira por Bancos no Paquistão — 1 Ano ou Mais (Exterior)', value: 'pk_swift_9644' },
  { text: 'Resgate de Aplicações no Paquistão ou SBP — 1 Ano ou Mais', value: 'pk_swift_9645' },
  { text: 'Resgate de Aplicações em Bancos no Exterior — 1 Ano ou Mais', value: 'pk_swift_9646' },
  { text: 'Captações de Longo Prazo por Não Bancos do Exterior', value: 'pk_swift_9647' },
  { text: 'Remessas de Participação Acionária até 10% — Contas Especiais em Moeda Estrangeira', value: 'pk_swift_9648' },
  { text: 'Remessas de Participação Acionária acima de 10% — Contas Especiais em Moeda Estrangeira', value: 'pk_swift_9649' },
  { text: 'Empréstimos Intercompany de Curto Prazo (Participação >= 10%) — Contas FCA Especiais', value: 'pk_swift_9650' },
  { text: 'Empréstimos do Exterior — Contas FCA Especiais de Empresas', value: 'pk_swift_9651' },
  { text: 'Qarz-e-Hasna (Empréstimo Islâmico sem Juros)', value: 'pk_swift_9652' },
  { text: 'Remessas para Compra de Imóveis e Negócios por Imigrantes', value: 'pk_swift_9653' },
  { text: 'Empréstimos Intercompany de Longo Prazo (Participação >= 10%) — Contas FCA Especiais', value: 'pk_swift_9654' },
  { text: 'Seguro de Vida — Prêmios e Suplementos de Renda de Investimento', value: 'pk_swift_9668' },
  { text: 'Seguro de Vida — Sinistros', value: 'pk_swift_9669' },
  { text: 'Reembolso de Missões Diplomáticas Paquistanesas no Exterior', value: 'pk_swift_9673' },
  { text: 'Empréstimos Externos de Curto Prazo do Governo — Serviço da Dívida', value: 'pk_swift_9674' },
  { text: 'Reembolsos de Empréstimos de Longo Prazo com Recursos Próprios', value: 'pk_swift_9675' },
  { text: 'Estorno — Reembolso de Principal de Empréstimos Externos de Longo Prazo', value: 'pk_swift_9676' },
  { text: 'Empréstimos Externos em Dinheiro — 1 Ano ou Mais — Serviço da Dívida', value: 'pk_swift_9677' },
  { text: 'Estorno de Remessas para Fins Especiais', value: 'pk_swift_9678' },
  { text: 'Exportação de Notas e Moedas em Moeda Estrangeira', value: 'pk_swift_9681' },
  { text: 'Cheques e Ordens Bancárias em Moeda Estrangeira — Venda de Notas', value: 'pk_swift_9682' },
  { text: 'Superávit de Agentes de Frete e Despachantes', value: 'pk_swift_9693' },
  { text: 'Devolução de Saldo por Empresas de Navegação Estrangeiras no Paquistão', value: 'pk_swift_9694' },
  { text: 'Devolução de Saldo por Companhias Aéreas Estrangeiras no Paquistão', value: 'pk_swift_9695' },
  { text: 'Reembolso de Créditos de Fornecedores Não Sujeitos a Serviço da Dívida', value: 'pk_swift_9697' },
  { text: 'Fundos Recebidos no Paquistão de FCA Offshore Própria (Form R)', value: 'pk_swift_9698' },
  { text: 'Fundos Recebidos em FCA Onshore de FCA Offshore Permissível', value: 'pk_swift_9699' },
  { text: 'Custo de Amostras de Exportação', value: 'pk_swift_9703' },
  { text: 'E-commerce — Produtos Digitais', value: 'pk_swift_9707' },
  { text: 'E-commerce — Serviços Digitais', value: 'pk_swift_9708' },
];
